/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { COINSharedApplicationProtosResponsesStatusResponse } from '@coin/shared/core/util-models';
import { MeritCommunicationSettingsMeritCommunicationSettingsModel } from '@coin/shared/core/util-models';
import { MeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel } from '@coin/shared/core/util-models';
import { PositionEvaluationSimulationsPositionEvaluationSimulationModel } from '@coin/shared/core/util-models';
import { SeasonsBudgetBucketsBudgetBucketModel } from '@coin/shared/core/util-models';
import { SeasonsBudgetBucketsBudgetBucketModificationResponseModel } from '@coin/shared/core/util-models';
import { SeasonsBudgetBucketsUpdateBudgetBucketModel } from '@coin/shared/core/util-models';
import { SeasonsBudgetBucketsUpdateManyBudgetBucketsModel } from '@coin/shared/core/util-models';
import { SeasonsBudgetComponentsBucketComponentModificationResponseModel } from '@coin/shared/core/util-models';
import { SeasonsBudgetComponentsBucketComponentsPossibilitiesModel } from '@coin/shared/core/util-models';
import { SeasonsBudgetComponentsCreateBucketComponentModel } from '@coin/shared/core/util-models';
import { SeasonsBudgetComponentsCreateManyBucketComponentsModel } from '@coin/shared/core/util-models';
import { SeasonsBudgetComponentsUpdateBucketComponentModel } from '@coin/shared/core/util-models';
import { SeasonsBudgetComponentsUpdateManyBucketComponentsModel } from '@coin/shared/core/util-models';
import { SeasonsCandidatePoolsCandidatePoolModel } from '@coin/shared/core/util-models';
import { SeasonsCandidatePoolsCreateCandidatePoolModel } from '@coin/shared/core/util-models';
import { SeasonsCandidatePoolsUpdateCandidatePoolModel } from '@coin/shared/core/util-models';
import { SeasonsCommunicationSettingsUpdateCommunicationSettingsModel } from '@coin/shared/core/util-models';
import { SeasonsEmployeeSnapshotsCreateEmployeeSnapshotModel } from '@coin/shared/core/util-models';
import { SeasonsEmployeeSnapshotsEmployeeSnapshotModel } from '@coin/shared/core/util-models';
import { SeasonsEmployeeSnapshotsUpdateEmployeeSnapshotModel } from '@coin/shared/core/util-models';
import { SeasonsEmployeeSnapshotsUpdateEmployeeSnapshotPartialModel } from '@coin/shared/core/util-models';
import { SeasonsInformationVisibilitySettingsCreateInformationVisibilitySettingsModel } from '@coin/shared/core/util-models';
import { SeasonsInformationVisibilitySettingsUpdateInformationVisibilitySettingsModel } from '@coin/shared/core/util-models';
import { SeasonsMembersCreateMemberModel } from '@coin/shared/core/util-models';
import { SeasonsMembersEmployeeSeasonOverviewModel } from '@coin/shared/core/util-models';
import { SeasonsMembersMemberModel } from '@coin/shared/core/util-models';
import { SeasonsMembersUpdateMemberModel } from '@coin/shared/core/util-models';
import { SeasonsOrganisationInformationSnapshotsCreateOrganisationInformationSnapshotModel } from '@coin/shared/core/util-models';
import { SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel } from '@coin/shared/core/util-models';
import { SeasonsOrganisationInformationSnapshotsUpdateOrganisationInformationSnapshotModel } from '@coin/shared/core/util-models';
import { SeasonsOrganisationSnapshotsOrganisationSnapshotModel } from '@coin/shared/core/util-models';
import { SeasonsOrganisationSnapshotsOrganisationSnapshotTreeItemModel } from '@coin/shared/core/util-models';
import { SeasonsPlanSettingsCreatePlanSettingsModel } from '@coin/shared/core/util-models';
import { SeasonsPlanSettingsPlanSettingsModel } from '@coin/shared/core/util-models';
import { SeasonsPlanSettingsUpdatePlanSettingsModel } from '@coin/shared/core/util-models';
import { SeasonsPlansCreatePlanModel } from '@coin/shared/core/util-models';
import { SeasonsPlansPlanModel } from '@coin/shared/core/util-models';
import { SeasonsPlansUpdatePlanModel } from '@coin/shared/core/util-models';
import { SeasonsPrioritiesChangeManyPrioritiesModel } from '@coin/shared/core/util-models';
import { SeasonsPublicationSettingsCreatePublicationSettingsModel } from '@coin/shared/core/util-models';
import { SeasonsPublicationSettingsPublicationSettingsModel } from '@coin/shared/core/util-models';
import { SeasonsPublicationSettingsUpdatePublicationSettingsModel } from '@coin/shared/core/util-models';
import { SeasonsRecordsRecordModel } from '@coin/shared/core/util-models';
import { SeasonsRemEmployeePopulationCreatedResultPagedDto } from '@coin/shared/core/util-models';
import { SeasonsRemExportEmployeePopulationResultDto } from '@coin/shared/core/util-models';
import { SeasonsRemPopulationCreatedResultPagedDto } from '@coin/shared/core/util-models';
import { SeasonsSeasonsCreateSeasonModel } from '@coin/shared/core/util-models';
import { SeasonsSeasonsDuplicateSeasonModel } from '@coin/shared/core/util-models';
import { SeasonsSeasonsSeasonModel } from '@coin/shared/core/util-models';
import { SeasonsSeasonsUpdateSeasonModel } from '@coin/shared/core/util-models';
import { SeasonsSettingsSeasonSettingsModel } from '@coin/shared/core/util-models';
import { SeasonsSettingsSetSeasonSettingsModel } from '@coin/shared/core/util-models';
import { SeasonsSimulationPublicationsPublishSimulationModel } from '@coin/shared/core/util-models';
import { SeasonsSimulationPublicationsUnPublishSimulationModel } from '@coin/shared/core/util-models';
import { SeasonsSimulationsCalculateManySimulationsModel } from '@coin/shared/core/util-models';
import { SeasonsSimulationsCalculateSimulationModel } from '@coin/shared/core/util-models';
import { SeasonsSimulationsCreateSimulationModel } from '@coin/shared/core/util-models';
import { SeasonsSimulationsSimulationModel } from '@coin/shared/core/util-models';
import { SeasonsSimulationsUpdateSimulationMembersModel } from '@coin/shared/core/util-models';
import { SeasonsSimulationsUpdateSimulationModel } from '@coin/shared/core/util-models';
import { SeasonsSnapshotsSnapshotModel } from '@coin/shared/core/util-models';
import { SeasonsSnapshotsUpdateSnapshotBenchmarkValuesModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmployeesEmployeesEmployeeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfMeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfPositionEvaluationEmployeeCandidatesPositionEvaluationCandidateModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSeasonsEmployeeSnapshotsEmployeeSnapshotModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSeasonsMembersMemberModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSeasonsOrganisationSnapshotsOrganisationSnapshotModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSeasonsPlanWithMissingIndividualValuesPlanWithMissingIndividualValuesModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSeasonsPlansPlanModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSeasonsRecordsRecordModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSeasonsSeasonsSeasonModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSeasonsSnapshotsSnapshotModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSpecialPaymentsGlobalHrbpRulesSpecialPaymentGlobalHrbpApproverRuleModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSystemString } from '@coin/shared/core/util-models';
import { SharedRuleEngineRuleSetModel } from '@coin/shared/core/util-models';
import { SpecialPaymentsGlobalHrbpRulesCreateSpecialPaymentGlobalHrbpApproverRuleModel } from '@coin/shared/core/util-models';
import { SpecialPaymentsGlobalHrbpRulesSpecialPaymentGlobalHrbpApproverRuleModel } from '@coin/shared/core/util-models';
import { SpecialPaymentsGlobalHrbpRulesUpdateSpecialPaymentGlobalHrbpApproverRuleModel } from '@coin/shared/core/util-models';
import { TransactionStatusOfCalculationStatus } from '@coin/shared/core/util-models';
import { TransactionStatusOfCandidatePoolRecalculationMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfIMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfImportStatusMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfMassSimulationCalculationMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfPlanPopulationCreationMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfPlanPopulationRecalculationMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfPopulationCreationMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfSettingsPopulationRecalculationMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfSimpleStatusMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfSimulationPublishMetadata } from '@coin/shared/core/util-models';

import { CustomHttpParameterCodec } from '../encoder';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

export interface SeasonsSpecialPaymentAdminServiceCalculateManySimulationRequestParams {
  seasonId: string;
  seasonsSimulationsCalculateManySimulationsModel?: SeasonsSimulationsCalculateManySimulationsModel;
}

export interface SeasonsSpecialPaymentAdminServiceCalculateSimulationRequestParams {
  seasonId: string;
  seasonsSimulationsCalculateSimulationModel?: SeasonsSimulationsCalculateSimulationModel;
}

export interface SeasonsSpecialPaymentAdminServiceChangePrioritiesInformationVisibilitySettingsRequestParams {
  simulationId: string;
  seasonsPrioritiesChangeManyPrioritiesModel?: SeasonsPrioritiesChangeManyPrioritiesModel;
}

export interface SeasonsSpecialPaymentAdminServiceChangePrioritiesPlansRequestParams {
  seasonsPrioritiesChangeManyPrioritiesModel?: SeasonsPrioritiesChangeManyPrioritiesModel;
}

export interface SeasonsSpecialPaymentAdminServiceCreateBudgetComponentsRequestParams {
  budgetBucketId: string;
  seasonsBudgetComponentsCreateBucketComponentModel?: SeasonsBudgetComponentsCreateBucketComponentModel;
}

export interface SeasonsSpecialPaymentAdminServiceCreateCandidatePoolsRequestParams {
  seasonsCandidatePoolsCreateCandidatePoolModel?: SeasonsCandidatePoolsCreateCandidatePoolModel;
}

export interface SeasonsSpecialPaymentAdminServiceCreateEmployeeSnapshotsRequestParams {
  seasonsEmployeeSnapshotsCreateEmployeeSnapshotModel?: SeasonsEmployeeSnapshotsCreateEmployeeSnapshotModel;
}

export interface SeasonsSpecialPaymentAdminServiceCreateInformationVisibilitySettingsRequestParams {
  simulationId: string;
  seasonsInformationVisibilitySettingsCreateInformationVisibilitySettingsModel?: SeasonsInformationVisibilitySettingsCreateInformationVisibilitySettingsModel;
}

export interface SeasonsSpecialPaymentAdminServiceCreateManyBudgetComponentsRequestParams {
  budgetBucketId: string;
  seasonsBudgetComponentsCreateManyBucketComponentsModel?: SeasonsBudgetComponentsCreateManyBucketComponentsModel;
}

export interface SeasonsSpecialPaymentAdminServiceCreateMembersRequestParams {
  seasonsMembersCreateMemberModel?: SeasonsMembersCreateMemberModel;
}

export interface SeasonsSpecialPaymentAdminServiceCreateOrganisationInformationSnapshotsRequestParams {
  seasonId: string;
  seasonsOrganisationInformationSnapshotsCreateOrganisationInformationSnapshotModel?: SeasonsOrganisationInformationSnapshotsCreateOrganisationInformationSnapshotModel;
}

export interface SeasonsSpecialPaymentAdminServiceCreatePlanSettingsRequestParams {
  planId: string;
  seasonsPlanSettingsCreatePlanSettingsModel?: SeasonsPlanSettingsCreatePlanSettingsModel;
}

export interface SeasonsSpecialPaymentAdminServiceCreatePlansRequestParams {
  seasonsPlansCreatePlanModel?: SeasonsPlansCreatePlanModel;
}

export interface SeasonsSpecialPaymentAdminServiceCreatePublicationSettingsRequestParams {
  seasonId: string;
  seasonsPublicationSettingsCreatePublicationSettingsModel?: SeasonsPublicationSettingsCreatePublicationSettingsModel;
}

export interface SeasonsSpecialPaymentAdminServiceCreateSeasonsRequestParams {
  seasonsSeasonsCreateSeasonModel?: SeasonsSeasonsCreateSeasonModel;
}

export interface SeasonsSpecialPaymentAdminServiceCreateSimulationRequestParams {
  seasonsSimulationsCreateSimulationModel?: SeasonsSimulationsCreateSimulationModel;
}

export interface SeasonsSpecialPaymentAdminServiceCreateSpecialPaymentGlobalHrbpApproverRulesRequestParams {
  seasonId: string;
  specialPaymentsGlobalHrbpRulesCreateSpecialPaymentGlobalHrbpApproverRuleModel?: SpecialPaymentsGlobalHrbpRulesCreateSpecialPaymentGlobalHrbpApproverRuleModel;
}

export interface SeasonsSpecialPaymentAdminServiceDeleteBudgetComponentsRequestParams {
  budgetBucketId: string;
}

export interface SeasonsSpecialPaymentAdminServiceDeleteCandidatePoolsRequestParams {
  id: string;
}

export interface SeasonsSpecialPaymentAdminServiceDeleteEmployeeSnapshotsRequestParams {
  snapshotId: string;
}

export interface SeasonsSpecialPaymentAdminServiceDeleteMembersRequestParams {
  id: string;
}

export interface SeasonsSpecialPaymentAdminServiceDeleteOrganisationInformationSnapshotsRequestParams {
  id: string;
  seasonId: string;
}

export interface SeasonsSpecialPaymentAdminServiceDeletePlanSettingsRequestParams {
  id: string;
  planId: string;
}

export interface SeasonsSpecialPaymentAdminServiceDeletePlansRequestParams {
  id: string;
}

export interface SeasonsSpecialPaymentAdminServiceDeleteSeasonsRequestParams {
  id: string;
}

export interface SeasonsSpecialPaymentAdminServiceDeleteSimulationSettingsRequestParams {
  id: string;
  seasonId: string;
  simulationId: string;
  settingsType?:
    | 'Merit'
    | 'Equity'
    | 'EquitySub'
    | 'Validation'
    | 'Placement'
    | 'ValidationHr'
    | 'PlacementHr'
    | 'Other'
    | 'NewHirePlan'
    | 'NewHireMerit'
    | 'NewHireEquity'
    | 'NewHireEquitySub'
    | 'IndividualMultiplier'
    | 'InformationVisibility'
    | 'Incentive'
    | 'NewHireIncentive'
    | 'IncentiveSub'
    | 'NewHireIncentiveSub';
}

export interface SeasonsSpecialPaymentAdminServiceDeleteSpecialPaymentGlobalHrbpApproverRulesRequestParams {
  seasonId: string;
  id: string;
}

export interface SeasonsSpecialPaymentAdminServiceDuplicateSeasonsRequestParams {
  id: string;
  seasonsSeasonsDuplicateSeasonModel?: SeasonsSeasonsDuplicateSeasonModel;
}

export interface SeasonsSpecialPaymentAdminServiceExportEmployeeCandidatesRequestParams {
  seasonId: string;
  queryGid?: string;
  queryFirstname?: string;
  queryLastname?: string;
  queryPAOrgCode?: Array<string>;
  queryCandidatePoolTitle?: Array<string>;
  queryOrgCode?: string;
  queryGender?: Array<'Male' | 'Female' | 'Undefined'>;
  queryOrgLevel?: Array<number>;
  queryMercerPositionClass?: Array<number>;
  queryIsPlaced?: boolean;
  queryIsShortlisted?: boolean;
  recordIds?: Array<string>;
  state?: 'Open' | 'Done';
  filename?: string;
}

export interface SeasonsSpecialPaymentAdminServiceExportOrganisationInformationSnapshotsRequestParams {
  seasonId: string;
  orgCode?: Array<string>;
  orgName?: Array<string>;
  orgSize?: number;
  revenue?: number;
  headCount?: number;
  revenueOrgSize?: number;
  headCountOrgSize?: number;
  fileName?: string;
}

export interface SeasonsSpecialPaymentAdminServiceExportPlanWithMissingIndividualValuesRequestParams {
  seasonId?: string;
}

export interface SeasonsSpecialPaymentAdminServiceExportSeasonPopulationsRequestParams {
  seasonId: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetBudgetBucketsRequestParams {
  id: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetBudgetBucketsPlansRequestParams {
  id: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetByIdRecordsRequestParams {
  /** id of the record entity */
  recordId: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetEmployeeSnapshotsRequestParams {
  snapshotId: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetInformationFieldValuesOrganisationInformationSnapshotsRequestParams {
  seasonId: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;
  orgCode?: Array<string>;
  page?: number;
  size?: number;
}

export interface SeasonsSpecialPaymentAdminServiceGetMembersRequestParams {
  id: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetMySeasonRecordsSeasonsRequestParams {
  id: string;
  memberId?: string;
  gid?: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetOfSeasonPublicationSettingsRequestParams {
  seasonId: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetOrganisationInformationSnapshotsRequestParams {
  id: string;
  seasonId: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetOrganisationSnapshotsRequestParams {
  seasonId: string;
  id: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetPlanPopulationPlansRequestParams {
  id: string;
  page?: number;
  size?: number;
}

export interface SeasonsSpecialPaymentAdminServiceGetPlanRecordsPlansRequestParams {
  id: string;
  page?: number;
  size?: number;
}

export interface SeasonsSpecialPaymentAdminServiceGetPlanSettingsRequestParams {
  planId: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetPlansRequestParams {
  id: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetPublicationSettingsRequestParams {
  id: string;
  seasonId: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetRecordsRequestParams {
  /**  */
  seasonId: string;
  memberId?: string;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  state?: Array<string>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  isDesignReady?: boolean;
  letterState?: Array<string>;
  payoutState?: Array<string>;
  template?: string;
  workflow?: string;
  seasonId2?: string;
  workflowInstanceState?: Array<string>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  lineManagerPositionClass?: number;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetSeasonCommunicationSettingsRequestParams {
  seasonId: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetSeasonOverviewForEmployeeMembersRequestParams {
  gid?: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetSeasonRecordsSeasonsRequestParams {
  id: string;
  queryId?: Array<string>;
  queryGid?: Array<string>;
  queryFirstName?: Array<string>;
  queryLastName?: Array<string>;
  queryCountry?: Array<string>;
  queryAre?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgClusterNodeName?: Array<string>;
  queryState?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  queryPlanName?: Array<string>;
  queryStartDate?: string;
  queryEndDate?: string;
  queryAssignmentId?: string;
  queryLetterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  queryProcessStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  queryRecordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  queryWorkflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryTemplate?: Array<string>;
  queryIsDesignReady?: boolean;
  queryPayoutDate?: string;
  queryPayoutState?: Array<
    'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'
  >;
  queryLineManagerName?: string;
  queryLineManagerGid?: Array<string>;
  querySeasonId?: string;
  queryWorkflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  queryMultiplier?: number;
  queryOverallTargetAchievement?: number;
  queryPayoutAmount?: number;
  queryPayoutCurrency?: Array<string>;
  queryIppAchievementValue?: string;
  queryIncentivePaymentType?: Array<string>;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  queryMeasurementDate?: string;
  queryMeritTitle?: Array<string>;
  queryEquityTitle?: Array<string>;
  queryEquitySubTitle?: Array<string>;
  queryManuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  queryNewHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  queryPromotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  queryTermination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  queryPopulationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  queryLineManagerFirstName?: Array<string>;
  queryLineManagerLastName?: Array<string>;
  queryCompanyManagerFirstName?: Array<string>;
  queryCompanyManagerGid?: Array<string>;
  queryCompanyManagerLastName?: Array<string>;
  queryTemplateName?: Array<string>;
  queryWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryAutoApprove?: boolean;
  queryApprovalRequired?: boolean;
  queryLetterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  queryProcessState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  queryExportState?: Array<'Open' | 'Done'>;
  queryPayrollState?: Array<'Open' | 'Done'>;
  queryMeritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  queryApprovedByCompanyManager?: boolean;
  queryAllocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryReadyToPayroll?: boolean;
  queryEquityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  queryHasOtpIncrease?: boolean;
  queryIsOtpOnly?: boolean;
  queryPlanTitle?: Array<string>;
  queryLocalCurrency?: Array<string>;
  queryProposalAmount?: number;
  queryProposalAmountInEuro?: number;
  queryProposalDate?: string;
  queryProposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  querySpecialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  querySpecialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  queryTemplateLetterName?: Array<string>;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetSeasonSettingsRequestParams {
  seasonId: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetSeasonsRequestParams {
  id: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetSimulationRequestParams {
  simulationId: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetSnapshotSeasonsRequestParams {
  id: string;
  employeeId: string;
}

export interface SeasonsSpecialPaymentAdminServiceGetTreeOrganisationSnapshotsRequestParams {
  seasonId: string;
  parentOrgCode?: string;
}

export interface SeasonsSpecialPaymentAdminServicePartialUpdateEmployeeSnapshotsRequestParams {
  snapshotId: string;
  seasonsEmployeeSnapshotsUpdateEmployeeSnapshotPartialModel?: SeasonsEmployeeSnapshotsUpdateEmployeeSnapshotPartialModel;
}

export interface SeasonsSpecialPaymentAdminServicePrePublishSimulationPublicationsRequestParams {
  simulationId: string;
  positionName?: Array<string>;
  orgCode?: Array<string>;
  orgCodeStartsWith?: Array<string>;
  orgLevel?: Array<number>;
  orgSize?: Array<number>;
  mercerJobCode?: Array<string>;
  positionClass?: Array<number>;
  newPositionClass?: Array<number>;
  originalProposedPositionClass?: Array<number>;
  positionType?: Array<string>;
  countryIsoCode?: Array<string>;
  incumbentGid?: Array<string>;
  incumbentFirstName?: Array<string>;
  incumbentLastName?: Array<string>;
  incumbentCountryPlaceOfAction?: Array<string>;
  validationManagerId?: Array<string>;
  validationManagerGid?: Array<string>;
  validationManagerFirstName?: Array<string>;
  validationManagerLastName?: Array<string>;
  validationState?: Array<string>;
  placementState?: Array<string>;
  newHireState?: Array<string>;
  isLocked?: Array<boolean>;
  mercerJobFamily?: Array<string>;
  mercerJobSpecialization?: Array<string>;
  mercerJobSubFamily?: Array<string>;
  incumbentAre?: Array<string>;
  tag?: Array<string>;
  wasPromoted?: Array<boolean>;
  isTransferred?: Array<boolean>;
  seasonsSimulationPublicationsPublishSimulationModel?: SeasonsSimulationPublicationsPublishSimulationModel;
}

export interface SeasonsSpecialPaymentAdminServicePublishSimulationPublicationsRequestParams {
  simulationId: string;
  queryPositionName?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgCodeStartsWith?: Array<string>;
  queryOrgLevel?: Array<number>;
  queryOrgSize?: Array<number>;
  queryMercerJobCode?: Array<string>;
  queryPositionClass?: Array<number>;
  queryNewPositionClass?: Array<number>;
  queryOriginalProposedPositionClass?: Array<number>;
  queryPositionType?: Array<string>;
  queryCountryIsoCode?: Array<string>;
  queryIncumbentGid?: Array<string>;
  queryIncumbentFirstName?: Array<string>;
  queryIncumbentLastName?: Array<string>;
  queryIncumbentCountryPlaceOfAction?: Array<string>;
  queryValidationManagerId?: Array<string>;
  queryValidationManagerGid?: Array<string>;
  queryValidationManagerFirstName?: Array<string>;
  queryValidationManagerLastName?: Array<string>;
  queryValidationState?: Array<string>;
  queryPlacementState?: Array<string>;
  queryNewHireState?: Array<string>;
  queryIsLocked?: Array<boolean>;
  queryMercerJobFamily?: Array<string>;
  queryMercerJobSpecialization?: Array<string>;
  queryMercerJobSubFamily?: Array<string>;
  queryIncumbentAre?: Array<string>;
  queryTag?: Array<string>;
  queryWasPromoted?: Array<boolean>;
  queryIsTransferred?: Array<boolean>;
  seasonsSimulationPublicationsPublishSimulationModel?: SeasonsSimulationPublicationsPublishSimulationModel;
}

export interface SeasonsSpecialPaymentAdminServiceQueryCandidatePoolsRequestParams {
  seasonId?: string;
}

export interface SeasonsSpecialPaymentAdminServiceQueryEmployeeCandidatesRequestParams {
  seasonId?: string;
  queryGid?: string;
  queryFirstname?: string;
  queryLastname?: string;
  queryPAOrgCode?: Array<string>;
  queryCandidatePoolTitle?: Array<string>;
  queryOrgCode?: string;
  queryGender?: Array<'Male' | 'Female' | 'Undefined'>;
  queryOrgLevel?: Array<number>;
  queryMercerPositionClass?: Array<number>;
  queryIsPlaced?: boolean;
  queryIsShortlisted?: boolean;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  pagingPage?: number;
  pagingSize?: number;
}

export interface SeasonsSpecialPaymentAdminServiceQueryEmployeeSnapshotsRequestParams {
  page?: number;
  size?: number;
}

export interface SeasonsSpecialPaymentAdminServiceQueryFieldValuesEmployeeCandidatesRequestParams {
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  seasonId?: string;
  pagingPage?: number;
  pagingSize?: number;
  gid?: string;
  firstname?: string;
  lastname?: string;
  pAOrgCode?: Array<string>;
  candidatePoolTitle?: Array<string>;
  orgCode?: string;
  gender?: Array<'Male' | 'Female' | 'Undefined'>;
  orgLevel?: Array<number>;
  mercerPositionClass?: Array<number>;
  isPlaced?: boolean;
  isShortlisted?: boolean;
}

export interface SeasonsSpecialPaymentAdminServiceQueryFieldValuesOrganisationSnapshotsRequestParams {
  seasonId: string;
  targetProperty?: 0;
  orgCode?: string;
  page?: number;
  size?: number;
}

export interface SeasonsSpecialPaymentAdminServiceQueryFieldValuesRecordsRequestParams {
  targetProperty: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17;
  memberId?: string;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  state?: Array<string>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  isDesignReady?: boolean;
  letterState?: Array<string>;
  payoutState?: Array<string>;
  template?: string;
  workflow?: string;
  seasonId?: string;
  workflowInstanceState?: Array<string>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  lineManagerPositionClass?: number;
  page?: number;
  size?: number;
}

export interface SeasonsSpecialPaymentAdminServiceQueryInformationOrganisationInformationSnapshotsRequestParams {
  seasonId: string;
  orgCode?: Array<string>;
  orgName?: Array<string>;
  orgSize?: number;
  revenue?: number;
  headCount?: number;
  revenueOrgSize?: number;
  headCountOrgSize?: number;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface SeasonsSpecialPaymentAdminServiceQueryInformationVisibilitySettingsRequestParams {
  simulationId: string;
  queryTargetProperty?: 0 | 1 | 2 | 3;
  queryTargetTypeString?: string;
  querySimulationId?: string;
  queryPriority?: number;
  queryTitle?: string;
  queryAffectedCount?: number;
  queryType?: 'General' | 'Default';
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsSpecialPaymentAdminServiceQueryMembersRequestParams {
  page?: number;
  size?: number;
}

export interface SeasonsSpecialPaymentAdminServiceQueryOrganisationSnapshotsRequestParams {
  seasonId: string;
  querySeasonId?: string;
  queryOrganisationId?: string;
  queryOrgCode?: Array<string>;
  queryOrgLevel?: number;
  queryParentOrgCode?: string;
  queryHeadId?: string;
  queryHeadGid?: string;
  queryHeadName?: string;
  queryPositionName?: string;
  queryAdditionalLineOne?: string;
  queryAdditionalLineTwo?: string;
  queryAdditionalLineThree?: string;
  queryAdditionalLineFour?: string;
  queryOrgName?: string;
  queryOrgType?: string;
  queryOrgLevelA?: string;
  queryOrgLevelB?: string;
  queryOrgLevelC?: string;
  queryOrgLevelD?: string;
  queryNumberOfEmployees?: number;
  queryHeadFirstname?: string;
  queryHeadLastname?: string;
  queryHeadPAOrgCode?: string;
  queryHeadPlaceOfAction?: string;
  queryHeadMercerJobCode?: string;
  queryHeadMercerPositionClass?: number;
  queryHeadManagementGroup?: string;
  queryOrgSize?: number;
  queryRevenue?: number;
  queryHeadCount?: number;
  queryRevenueOrgSize?: number;
  queryHeadCountOrgSize?: number;
  queryShowOrganisationsWithoutOrgInfos?: boolean;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsSpecialPaymentAdminServiceQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsRequestParams {
  seasonId?: string;
  meritSeasonId?: string;
  search?: string;
  directs?: boolean;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  impersonatedEmployee?: string;
}

export interface SeasonsSpecialPaymentAdminServiceQueryParentsOrganisationSnapshotsRequestParams {
  seasonId: string;
  seasonId2: string;
  queryOrgCode?: string;
}

export interface SeasonsSpecialPaymentAdminServiceQueryPlanWithMissingIndividualValuesRequestParams {
  seasonId?: string;
  queryKpiId?: string;
  queryAssignmentId?: string;
  queryOrgClusterNodeName?: string;
  queryGid?: string;
  queryLastname?: string;
  queryFirstname?: string;
  queryCountry?: string;
  queryOrgCode?: string;
  queryRecordStartdate?: string;
  queryPlanName?: string;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsSpecialPaymentAdminServiceQueryPlansRequestParams {
  page?: number;
  size?: number;
  seasonId?: string;
}

export interface SeasonsSpecialPaymentAdminServiceQuerySeasonsRequestParams {
  page?: number;
  size?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  seasonType?: Array<
    | 'Unknown'
    | 'SOG'
    | 'GBR'
    | 'Merit'
    | 'IncentiveV2'
    | 'SpecialPaymentCash'
    | 'SpecialPaymentEquity'
    | 'PositionEvaluation'
    | 'Restructuring'
  >;
  simulationState?: Array<
    | 'Created'
    | 'Edited'
    | 'Simulating'
    | 'Simulated'
    | 'RecalculationRequired'
    | 'Ready'
    | 'Frozen'
    | 'Recalculating'
    | 'InAllocation'
    | 'PrePublished'
    | 'Calculating'
    | 'CalculationRequired'
    | 'Calculated'
    | 'Published'
    | 'UpdatingData'
  >;
  queryManagerEndDateAt?: string;
  queryPartnerEndDateAt?: string;
  querySeasonType?: Array<
    | 'Unknown'
    | 'SOG'
    | 'GBR'
    | 'Merit'
    | 'IncentiveV2'
    | 'SpecialPaymentCash'
    | 'SpecialPaymentEquity'
    | 'PositionEvaluation'
    | 'Restructuring'
  >;
  querySimulationState?: Array<
    | 'Created'
    | 'Edited'
    | 'Simulating'
    | 'Simulated'
    | 'RecalculationRequired'
    | 'Ready'
    | 'Frozen'
    | 'Recalculating'
    | 'InAllocation'
    | 'PrePublished'
    | 'Calculating'
    | 'CalculationRequired'
    | 'Calculated'
    | 'Published'
    | 'UpdatingData'
  >;
}

export interface SeasonsSpecialPaymentAdminServiceQuerySimulationRequestParams {
  seasonId: string;
}

export interface SeasonsSpecialPaymentAdminServiceQuerySpecialPaymentGlobalHrbpApproverRulesRequestParams {
  seasonId: string;
  page?: number;
  size?: number;
}

export interface SeasonsSpecialPaymentAdminServiceRecalculateParentSettingsPopulationSimulationPopulationsRequestParams {
  simulationId: string;
  parentSettingId: string;
  settingsType?:
    | 'Merit'
    | 'Equity'
    | 'EquitySub'
    | 'Validation'
    | 'Placement'
    | 'ValidationHr'
    | 'PlacementHr'
    | 'Other'
    | 'NewHirePlan'
    | 'NewHireMerit'
    | 'NewHireEquity'
    | 'NewHireEquitySub'
    | 'IndividualMultiplier'
    | 'InformationVisibility'
    | 'Incentive'
    | 'NewHireIncentive'
    | 'IncentiveSub'
    | 'NewHireIncentiveSub';
}

export interface SeasonsSpecialPaymentAdminServiceRecalculatePlanPopulationsRequestParams {
  seasonId: string;
}

export interface SeasonsSpecialPaymentAdminServiceRecalculateSettingsPopulationSimulationPopulationsRequestParams {
  simulationId: string;
  settingsType?:
    | 'Merit'
    | 'Equity'
    | 'EquitySub'
    | 'Validation'
    | 'Placement'
    | 'ValidationHr'
    | 'PlacementHr'
    | 'Other'
    | 'NewHirePlan'
    | 'NewHireMerit'
    | 'NewHireEquity'
    | 'NewHireEquitySub'
    | 'IndividualMultiplier'
    | 'InformationVisibility'
    | 'Incentive'
    | 'NewHireIncentive'
    | 'IncentiveSub'
    | 'NewHireIncentiveSub';
}

export interface SeasonsSpecialPaymentAdminServiceReorderSpecialPaymentGlobalHrbpApproverRulesRequestParams {
  seasonId: string;
  requestBody?: Array<string>;
}

export interface SeasonsSpecialPaymentAdminServiceSavePlanPopulationsRequestParams {
  id: string;
}

export interface SeasonsSpecialPaymentAdminServiceSaveSeasonPopulationsRequestParams {
  seasonId: string;
}

export interface SeasonsSpecialPaymentAdminServiceSimulatePlanPopulationsRequestParams {
  id: string;
  page?: number;
  size?: number;
  sharedRuleEngineRuleSetModel?: SharedRuleEngineRuleSetModel;
}

export interface SeasonsSpecialPaymentAdminServiceSimulateRuleInformationVisibilitySettingsRequestParams {
  settingsId: string;
  simulationId: string;
  page?: number;
  size?: number;
  sharedRuleEngineRuleSetModel?: SharedRuleEngineRuleSetModel;
}

export interface SeasonsSpecialPaymentAdminServiceSimulateSeasonPopulationsRequestParams {
  seasonId: string;
  page?: number;
  size?: number;
  _export?: boolean;
  sharedRuleEngineRuleSetModel?: SharedRuleEngineRuleSetModel;
}

export interface SeasonsSpecialPaymentAdminServiceUnPrePublishSimulationPublicationsRequestParams {
  simulationId: string;
}

export interface SeasonsSpecialPaymentAdminServiceUnPublishSimulationPublicationsRequestParams {
  simulationId: string;
  queryPositionName?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgCodeStartsWith?: Array<string>;
  queryOrgLevel?: Array<number>;
  queryOrgSize?: Array<number>;
  queryMercerJobCode?: Array<string>;
  queryPositionClass?: Array<number>;
  queryNewPositionClass?: Array<number>;
  queryOriginalProposedPositionClass?: Array<number>;
  queryPositionType?: Array<string>;
  queryCountryIsoCode?: Array<string>;
  queryIncumbentGid?: Array<string>;
  queryIncumbentFirstName?: Array<string>;
  queryIncumbentLastName?: Array<string>;
  queryIncumbentCountryPlaceOfAction?: Array<string>;
  queryValidationManagerId?: Array<string>;
  queryValidationManagerGid?: Array<string>;
  queryValidationManagerFirstName?: Array<string>;
  queryValidationManagerLastName?: Array<string>;
  queryValidationState?: Array<string>;
  queryPlacementState?: Array<string>;
  queryNewHireState?: Array<string>;
  queryIsLocked?: Array<boolean>;
  queryMercerJobFamily?: Array<string>;
  queryMercerJobSpecialization?: Array<string>;
  queryMercerJobSubFamily?: Array<string>;
  queryIncumbentAre?: Array<string>;
  queryTag?: Array<string>;
  queryWasPromoted?: Array<boolean>;
  queryIsTransferred?: Array<boolean>;
  seasonsSimulationPublicationsUnPublishSimulationModel?: SeasonsSimulationPublicationsUnPublishSimulationModel;
}

export interface SeasonsSpecialPaymentAdminServiceUpdateBenchmarkValuesSnapshotsRequestParams {
  seasonsSnapshotsUpdateSnapshotBenchmarkValuesModel?: SeasonsSnapshotsUpdateSnapshotBenchmarkValuesModel;
}

export interface SeasonsSpecialPaymentAdminServiceUpdateBucketComponentBatchBudgetComponentsRequestParams {
  budgetBucketId: string;
  seasonsBudgetComponentsUpdateManyBucketComponentsModel?: SeasonsBudgetComponentsUpdateManyBucketComponentsModel;
}

export interface SeasonsSpecialPaymentAdminServiceUpdateBucketComponentBudgetComponentsRequestParams {
  budgetBucketId: string;
  seasonsBudgetComponentsUpdateBucketComponentModel?: SeasonsBudgetComponentsUpdateBucketComponentModel;
}

export interface SeasonsSpecialPaymentAdminServiceUpdateBudgetBucketsRequestParams {
  id: string;
  seasonsBudgetBucketsUpdateBudgetBucketModel?: SeasonsBudgetBucketsUpdateBudgetBucketModel;
}

export interface SeasonsSpecialPaymentAdminServiceUpdateCandidatePoolsRequestParams {
  id: string;
  seasonsCandidatePoolsUpdateCandidatePoolModel?: SeasonsCandidatePoolsUpdateCandidatePoolModel;
}

export interface SeasonsSpecialPaymentAdminServiceUpdateEmployeeSnapshotsRequestParams {
  seasonsEmployeeSnapshotsUpdateEmployeeSnapshotModel?: SeasonsEmployeeSnapshotsUpdateEmployeeSnapshotModel;
}

export interface SeasonsSpecialPaymentAdminServiceUpdateInformationVisibilitySettingsRequestParams {
  settingsId: string;
  simulationId: string;
  seasonsInformationVisibilitySettingsUpdateInformationVisibilitySettingsModel?: SeasonsInformationVisibilitySettingsUpdateInformationVisibilitySettingsModel;
}

export interface SeasonsSpecialPaymentAdminServiceUpdateManyBudgetBucketsRequestParams {
  seasonsBudgetBucketsUpdateManyBudgetBucketsModel?: SeasonsBudgetBucketsUpdateManyBudgetBucketsModel;
}

export interface SeasonsSpecialPaymentAdminServiceUpdateMembersRequestParams {
  seasonsMembersUpdateMemberModel?: SeasonsMembersUpdateMemberModel;
}

export interface SeasonsSpecialPaymentAdminServiceUpdateOrganisationInformationSnapshotsRequestParams {
  seasonId: string;
  id: string;
  seasonsOrganisationInformationSnapshotsUpdateOrganisationInformationSnapshotModel?: SeasonsOrganisationInformationSnapshotsUpdateOrganisationInformationSnapshotModel;
}

export interface SeasonsSpecialPaymentAdminServiceUpdatePlanSettingsRequestParams {
  id: string;
  planId: string;
  seasonsPlanSettingsUpdatePlanSettingsModel?: SeasonsPlanSettingsUpdatePlanSettingsModel;
}

export interface SeasonsSpecialPaymentAdminServiceUpdatePlansRequestParams {
  id: string;
  seasonsPlansUpdatePlanModel?: SeasonsPlansUpdatePlanModel;
}

export interface SeasonsSpecialPaymentAdminServiceUpdatePublicationSettingsPublicationSettingsRequestParams {
  seasonId: string;
  seasonsPublicationSettingsUpdatePublicationSettingsModel?: SeasonsPublicationSettingsUpdatePublicationSettingsModel;
}

export interface SeasonsSpecialPaymentAdminServiceUpdateSeasonCommunicationSettingsRequestParams {
  seasonId: string;
  seasonsCommunicationSettingsUpdateCommunicationSettingsModel?: SeasonsCommunicationSettingsUpdateCommunicationSettingsModel;
}

export interface SeasonsSpecialPaymentAdminServiceUpdateSeasonSettingsRequestParams {
  seasonsSettingsSetSeasonSettingsModel?: SeasonsSettingsSetSeasonSettingsModel;
}

export interface SeasonsSpecialPaymentAdminServiceUpdateSeasonsRequestParams {
  seasonsSeasonsUpdateSeasonModel?: SeasonsSeasonsUpdateSeasonModel;
}

export interface SeasonsSpecialPaymentAdminServiceUpdateSimulationRequestParams {
  simulationId: string;
  seasonsSimulationsUpdateSimulationModel?: SeasonsSimulationsUpdateSimulationModel;
}

export interface SeasonsSpecialPaymentAdminServiceUpdateSimulationMembersSimulationRequestParams {
  seasonId: string;
  simulationId: string;
  seasonsSimulationsUpdateSimulationMembersModel?: SeasonsSimulationsUpdateSimulationMembersModel;
}

export interface SeasonsSpecialPaymentAdminServiceUpdateSpecialPaymentGlobalHrbpApproverRulesRequestParams {
  seasonId: string;
  id: string;
  specialPaymentsGlobalHrbpRulesUpdateSpecialPaymentGlobalHrbpApproverRuleModel?: SpecialPaymentsGlobalHrbpRulesUpdateSpecialPaymentGlobalHrbpApproverRuleModel;
}

/**
 * @deprecated The v1 API client is deprecated. Use the v2 client from `@coin/shared/core/data-access-v2` instead.
 */
@Injectable({
  providedIn: 'root'
})
export class SeasonsSpecialPaymentAdminService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach(elem => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          k => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public calculateManySimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCalculateManySimulationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfCalculationStatus>;
  public calculateManySimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCalculateManySimulationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfCalculationStatus>>;
  public calculateManySimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCalculateManySimulationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfCalculationStatus>>;
  public calculateManySimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCalculateManySimulationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling calculateManySimulation.');
    }
    const seasonsSimulationsCalculateManySimulationsModel =
      requestParameters?.seasonsSimulationsCalculateManySimulationsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/calculate`;
    return this.httpClient.request<TransactionStatusOfCalculationStatus>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSimulationsCalculateManySimulationsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public calculateSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCalculateSimulationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfMassSimulationCalculationMetadata>;
  public calculateSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCalculateSimulationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfMassSimulationCalculationMetadata>>;
  public calculateSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCalculateSimulationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfMassSimulationCalculationMetadata>>;
  public calculateSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCalculateSimulationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling calculateSimulation.');
    }
    const seasonsSimulationsCalculateSimulationModel = requestParameters?.seasonsSimulationsCalculateSimulationModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/mass-calculate`;
    return this.httpClient.request<TransactionStatusOfMassSimulationCalculationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSimulationsCalculateSimulationModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public changePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceChangePrioritiesInformationVisibilitySettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public changePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceChangePrioritiesInformationVisibilitySettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public changePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceChangePrioritiesInformationVisibilitySettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public changePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceChangePrioritiesInformationVisibilitySettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling changePrioritiesInformationVisibilitySettings.'
      );
    }
    const seasonsPrioritiesChangeManyPrioritiesModel = requestParameters?.seasonsPrioritiesChangeManyPrioritiesModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility/priorities`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsPrioritiesChangeManyPrioritiesModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public changePrioritiesPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceChangePrioritiesPlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public changePrioritiesPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceChangePrioritiesPlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public changePrioritiesPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceChangePrioritiesPlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public changePrioritiesPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceChangePrioritiesPlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const seasonsPrioritiesChangeManyPrioritiesModel = requestParameters?.seasonsPrioritiesChangeManyPrioritiesModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/plans/priorities`;
    return this.httpClient.request<any>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: seasonsPrioritiesChangeManyPrioritiesModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateBudgetComponentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsBudgetComponentsBucketComponentModificationResponseModel>;
  public createBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateBudgetComponentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsBudgetComponentsBucketComponentModificationResponseModel>>;
  public createBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateBudgetComponentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsBudgetComponentsBucketComponentModificationResponseModel>>;
  public createBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateBudgetComponentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    if (budgetBucketId === null || budgetBucketId === undefined) {
      throw new Error('Required parameter budgetBucketId was null or undefined when calling createBudgetComponents.');
    }
    const seasonsBudgetComponentsCreateBucketComponentModel =
      requestParameters?.seasonsBudgetComponentsCreateBucketComponentModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-components`;
    return this.httpClient.request<SeasonsBudgetComponentsBucketComponentModificationResponseModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsBudgetComponentsCreateBucketComponentModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateCandidatePoolsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsCandidatePoolsCandidatePoolModel>;
  public createCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateCandidatePoolsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsCandidatePoolsCandidatePoolModel>>;
  public createCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateCandidatePoolsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsCandidatePoolsCandidatePoolModel>>;
  public createCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateCandidatePoolsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsCandidatePoolsCreateCandidatePoolModel =
      requestParameters?.seasonsCandidatePoolsCreateCandidatePoolModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/candidate-pools`;
    return this.httpClient.request<SeasonsCandidatePoolsCandidatePoolModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsCandidatePoolsCreateCandidatePoolModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateEmployeeSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>;
  public createEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateEmployeeSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>>;
  public createEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateEmployeeSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>>;
  public createEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateEmployeeSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsEmployeeSnapshotsCreateEmployeeSnapshotModel =
      requestParameters?.seasonsEmployeeSnapshotsCreateEmployeeSnapshotModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/employee-snapshots`;
    return this.httpClient.request<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsEmployeeSnapshotsCreateEmployeeSnapshotModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateInformationVisibilitySettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<MeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>;
  public createInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateInformationVisibilitySettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<MeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>>;
  public createInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateInformationVisibilitySettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<MeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>>;
  public createInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateInformationVisibilitySettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling createInformationVisibilitySettings.'
      );
    }
    const seasonsInformationVisibilitySettingsCreateInformationVisibilitySettingsModel =
      requestParameters?.seasonsInformationVisibilitySettingsCreateInformationVisibilitySettingsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility`;
    return this.httpClient.request<MeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsInformationVisibilitySettingsCreateInformationVisibilitySettingsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createManyBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateManyBudgetComponentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsBudgetComponentsBucketComponentModificationResponseModel>;
  public createManyBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateManyBudgetComponentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsBudgetComponentsBucketComponentModificationResponseModel>>;
  public createManyBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateManyBudgetComponentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsBudgetComponentsBucketComponentModificationResponseModel>>;
  public createManyBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateManyBudgetComponentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    if (budgetBucketId === null || budgetBucketId === undefined) {
      throw new Error(
        'Required parameter budgetBucketId was null or undefined when calling createManyBudgetComponents.'
      );
    }
    const seasonsBudgetComponentsCreateManyBucketComponentsModel =
      requestParameters?.seasonsBudgetComponentsCreateManyBucketComponentsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/budget-components/batch`;
    return this.httpClient.request<SeasonsBudgetComponentsBucketComponentModificationResponseModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsBudgetComponentsCreateManyBucketComponentsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateMembersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsMembersMemberModel>;
  public createMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateMembersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsMembersMemberModel>>;
  public createMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateMembersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsMembersMemberModel>>;
  public createMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateMembersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsMembersCreateMemberModel = requestParameters?.seasonsMembersCreateMemberModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/members`;
    return this.httpClient.request<SeasonsMembersMemberModel>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: seasonsMembersCreateMemberModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateOrganisationInformationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>;
  public createOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateOrganisationInformationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>>;
  public createOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateOrganisationInformationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>>;
  public createOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateOrganisationInformationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling createOrganisationInformationSnapshots.'
      );
    }
    const seasonsOrganisationInformationSnapshotsCreateOrganisationInformationSnapshotModel =
      requestParameters?.seasonsOrganisationInformationSnapshotsCreateOrganisationInformationSnapshotModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information`;
    return this.httpClient.request<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsOrganisationInformationSnapshotsCreateOrganisationInformationSnapshotModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreatePlanSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsPlanSettingsPlanSettingsModel>;
  public createPlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreatePlanSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsPlanSettingsPlanSettingsModel>>;
  public createPlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreatePlanSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsPlanSettingsPlanSettingsModel>>;
  public createPlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreatePlanSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const planId = requestParameters?.planId;
    if (planId === null || planId === undefined) {
      throw new Error('Required parameter planId was null or undefined when calling createPlanSettings.');
    }
    const seasonsPlanSettingsCreatePlanSettingsModel = requestParameters?.seasonsPlanSettingsCreatePlanSettingsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings`;
    return this.httpClient.request<SeasonsPlanSettingsPlanSettingsModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsPlanSettingsCreatePlanSettingsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreatePlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsPlansPlanModel>;
  public createPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreatePlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsPlansPlanModel>>;
  public createPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreatePlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsPlansPlanModel>>;
  public createPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreatePlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsPlansCreatePlanModel = requestParameters?.seasonsPlansCreatePlanModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/plans`;
    return this.httpClient.request<SeasonsPlansPlanModel>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: seasonsPlansCreatePlanModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreatePublicationSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsPublicationSettingsPublicationSettingsModel>;
  public createPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreatePublicationSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsPublicationSettingsPublicationSettingsModel>>;
  public createPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreatePublicationSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsPublicationSettingsPublicationSettingsModel>>;
  public createPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreatePublicationSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling createPublicationSettings.');
    }
    const seasonsPublicationSettingsCreatePublicationSettingsModel =
      requestParameters?.seasonsPublicationSettingsCreatePublicationSettingsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publication-settings`;
    return this.httpClient.request<SeasonsPublicationSettingsPublicationSettingsModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsPublicationSettingsCreatePublicationSettingsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateSeasonsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsSeasonsSeasonModel>;
  public createSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateSeasonsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsSeasonsSeasonModel>>;
  public createSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateSeasonsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsSeasonsSeasonModel>>;
  public createSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateSeasonsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsSeasonsCreateSeasonModel = requestParameters?.seasonsSeasonsCreateSeasonModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons`;
    return this.httpClient.request<SeasonsSeasonsSeasonModel>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: seasonsSeasonsCreateSeasonModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateSimulationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfIMetadata>;
  public createSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateSimulationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfIMetadata>>;
  public createSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateSimulationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfIMetadata>>;
  public createSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateSimulationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsSimulationsCreateSimulationModel = requestParameters?.seasonsSimulationsCreateSimulationModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/simulations`;
    return this.httpClient.request<TransactionStatusOfIMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSimulationsCreateSimulationModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateSpecialPaymentGlobalHrbpApproverRulesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SpecialPaymentsGlobalHrbpRulesSpecialPaymentGlobalHrbpApproverRuleModel>;
  public createSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateSpecialPaymentGlobalHrbpApproverRulesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SpecialPaymentsGlobalHrbpRulesSpecialPaymentGlobalHrbpApproverRuleModel>>;
  public createSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateSpecialPaymentGlobalHrbpApproverRulesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SpecialPaymentsGlobalHrbpRulesSpecialPaymentGlobalHrbpApproverRuleModel>>;
  public createSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: SeasonsSpecialPaymentAdminServiceCreateSpecialPaymentGlobalHrbpApproverRulesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling createSpecialPaymentGlobalHrbpApproverRules.'
      );
    }
    const specialPaymentsGlobalHrbpRulesCreateSpecialPaymentGlobalHrbpApproverRuleModel =
      requestParameters?.specialPaymentsGlobalHrbpRulesCreateSpecialPaymentGlobalHrbpApproverRuleModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/global-hrbp-rules`;
    return this.httpClient.request<SpecialPaymentsGlobalHrbpRulesSpecialPaymentGlobalHrbpApproverRuleModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: specialPaymentsGlobalHrbpRulesCreateSpecialPaymentGlobalHrbpApproverRuleModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteBudgetComponentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteBudgetComponentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteBudgetComponentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteBudgetComponentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    if (budgetBucketId === null || budgetBucketId === undefined) {
      throw new Error('Required parameter budgetBucketId was null or undefined when calling deleteBudgetComponents.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-components`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteCandidatePoolsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteCandidatePoolsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteCandidatePoolsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteCandidatePoolsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteCandidatePools.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/candidate-pools/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteEmployeeSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteEmployeeSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteEmployeeSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteEmployeeSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const snapshotId = requestParameters?.snapshotId;
    if (snapshotId === null || snapshotId === undefined) {
      throw new Error('Required parameter snapshotId was null or undefined when calling deleteEmployeeSnapshots.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/employee-snapshots/${this.configuration.encodeParam({ name: 'snapshotId', value: snapshotId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteMembersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteMembersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteMembersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteMembersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteMembers.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/members/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteOrganisationInformationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<boolean>;
  public deleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteOrganisationInformationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<boolean>>;
  public deleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteOrganisationInformationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<boolean>>;
  public deleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteOrganisationInformationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling deleteOrganisationInformationSnapshots.'
      );
    }
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling deleteOrganisationInformationSnapshots.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/snapshots/organisations/information/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<boolean>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeletePlanSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deletePlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeletePlanSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deletePlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeletePlanSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deletePlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeletePlanSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deletePlanSettings.');
    }
    const planId = requestParameters?.planId;
    if (planId === null || planId === undefined) {
      throw new Error('Required parameter planId was null or undefined when calling deletePlanSettings.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeletePlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deletePlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeletePlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deletePlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeletePlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deletePlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeletePlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deletePlans.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteSeasonsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteSeasonsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteSeasonsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteSeasonsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteSeasons.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteSimulationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteSimulationSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteSimulationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteSimulationSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteSimulationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteSimulationSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteSimulationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteSimulationSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteSimulationSettings.');
    }
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling deleteSimulationSettings.');
    }
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error('Required parameter simulationId was null or undefined when calling deleteSimulationSettings.');
    }
    const settingsType = requestParameters?.settingsType;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (settingsType !== undefined && settingsType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>settingsType, 'settingsType');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteSpecialPaymentGlobalHrbpApproverRulesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<boolean>;
  public deleteSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteSpecialPaymentGlobalHrbpApproverRulesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<boolean>>;
  public deleteSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteSpecialPaymentGlobalHrbpApproverRulesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<boolean>>;
  public deleteSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDeleteSpecialPaymentGlobalHrbpApproverRulesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling deleteSpecialPaymentGlobalHrbpApproverRules.'
      );
    }
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling deleteSpecialPaymentGlobalHrbpApproverRules.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/global-hrbp-rules/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<boolean>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public duplicateSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDuplicateSeasonsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSimpleStatusMetadata>;
  public duplicateSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDuplicateSeasonsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSimpleStatusMetadata>>;
  public duplicateSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDuplicateSeasonsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSimpleStatusMetadata>>;
  public duplicateSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceDuplicateSeasonsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling duplicateSeasons.');
    }
    const seasonsSeasonsDuplicateSeasonModel = requestParameters?.seasonsSeasonsDuplicateSeasonModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/duplicate`;
    return this.httpClient.request<TransactionStatusOfSimpleStatusMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSeasonsDuplicateSeasonModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminServiceExportEmployeeCandidatesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminServiceExportEmployeeCandidatesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminServiceExportEmployeeCandidatesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminServiceExportEmployeeCandidatesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling exportEmployeeCandidates.');
    }
    const queryGid = requestParameters?.queryGid;
    const queryFirstname = requestParameters?.queryFirstname;
    const queryLastname = requestParameters?.queryLastname;
    const queryPAOrgCode = requestParameters?.queryPAOrgCode;
    const queryCandidatePoolTitle = requestParameters?.queryCandidatePoolTitle;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryGender = requestParameters?.queryGender;
    const queryOrgLevel = requestParameters?.queryOrgLevel;
    const queryMercerPositionClass = requestParameters?.queryMercerPositionClass;
    const queryIsPlaced = requestParameters?.queryIsPlaced;
    const queryIsShortlisted = requestParameters?.queryIsShortlisted;
    const recordIds = requestParameters?.recordIds;
    const state = requestParameters?.state;
    const filename = requestParameters?.filename;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryGid !== undefined && queryGid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryGid, 'Query.Gid');
    }
    if (queryFirstname !== undefined && queryFirstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryFirstname, 'Query.Firstname');
    }
    if (queryLastname !== undefined && queryLastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryLastname, 'Query.Lastname');
    }
    if (queryPAOrgCode) {
      queryPAOrgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PAOrgCode');
      });
    }
    if (queryCandidatePoolTitle) {
      queryCandidatePoolTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.CandidatePoolTitle'
        );
      });
    }
    if (queryOrgCode !== undefined && queryOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgCode, 'Query.OrgCode');
    }
    if (queryGender) {
      queryGender.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Gender');
      });
    }
    if (queryOrgLevel) {
      queryOrgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgLevel');
      });
    }
    if (queryMercerPositionClass) {
      queryMercerPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.MercerPositionClass'
        );
      });
    }
    if (queryIsPlaced !== undefined && queryIsPlaced !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryIsPlaced, 'Query.IsPlaced');
    }
    if (queryIsShortlisted !== undefined && queryIsShortlisted !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryIsShortlisted,
        'Query.IsShortlisted'
      );
    }
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }
    if (recordIds) {
      recordIds.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'RecordIds');
      });
    }
    if (state !== undefined && state !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>state, 'State');
    }
    if (filename !== undefined && filename !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filename, 'Filename');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/employee-candidates/export`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceExportOrganisationInformationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceExportOrganisationInformationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceExportOrganisationInformationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceExportOrganisationInformationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling exportOrganisationInformationSnapshots.'
      );
    }
    const orgCode = requestParameters?.orgCode;
    const orgName = requestParameters?.orgName;
    const orgSize = requestParameters?.orgSize;
    const revenue = requestParameters?.revenue;
    const headCount = requestParameters?.headCount;
    const revenueOrgSize = requestParameters?.revenueOrgSize;
    const headCountOrgSize = requestParameters?.headCountOrgSize;
    const fileName = requestParameters?.fileName;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgName) {
      orgName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgName');
      });
    }
    if (orgSize !== undefined && orgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgSize, 'OrgSize');
    }
    if (revenue !== undefined && revenue !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>revenue, 'Revenue');
    }
    if (headCount !== undefined && headCount !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>headCount, 'HeadCount');
    }
    if (revenueOrgSize !== undefined && revenueOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>revenueOrgSize, 'RevenueOrgSize');
    }
    if (headCountOrgSize !== undefined && headCountOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>headCountOrgSize,
        'HeadCountOrgSize'
      );
    }
    if (fileName !== undefined && fileName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>fileName, 'fileName');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information/export`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsSpecialPaymentAdminServiceExportPlanWithMissingIndividualValuesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsSpecialPaymentAdminServiceExportPlanWithMissingIndividualValuesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsSpecialPaymentAdminServiceExportPlanWithMissingIndividualValuesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsSpecialPaymentAdminServiceExportPlanWithMissingIndividualValuesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/season-plans/missing-individual-values`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceExportSeasonPopulationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsRemExportEmployeePopulationResultDto>;
  public exportSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceExportSeasonPopulationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsRemExportEmployeePopulationResultDto>>;
  public exportSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceExportSeasonPopulationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsRemExportEmployeePopulationResultDto>>;
  public exportSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceExportSeasonPopulationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling exportSeasonPopulations.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/export-population`;
    return this.httpClient.request<SeasonsRemExportEmployeePopulationResultDto>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetBudgetBucketsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsBudgetBucketsBudgetBucketModel>;
  public getBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetBudgetBucketsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsBudgetBucketsBudgetBucketModel>>;
  public getBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetBudgetBucketsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsBudgetBucketsBudgetBucketModel>>;
  public getBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetBudgetBucketsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getBudgetBuckets.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/budget-bucket/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsBudgetBucketsBudgetBucketModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBudgetBucketsPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetBudgetBucketsPlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<SeasonsBudgetBucketsBudgetBucketModel>>;
  public getBudgetBucketsPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetBudgetBucketsPlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<SeasonsBudgetBucketsBudgetBucketModel>>>;
  public getBudgetBucketsPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetBudgetBucketsPlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<SeasonsBudgetBucketsBudgetBucketModel>>>;
  public getBudgetBucketsPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetBudgetBucketsPlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getBudgetBucketsPlans.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-buckets`;
    return this.httpClient.request<Array<SeasonsBudgetBucketsBudgetBucketModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Search for specific record entity by id
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getByIdRecords(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetByIdRecordsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsRecordsRecordModel>;
  public getByIdRecords(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetByIdRecordsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsRecordsRecordModel>>;
  public getByIdRecords(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetByIdRecordsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsRecordsRecordModel>>;
  public getByIdRecords(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetByIdRecordsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const recordId = requestParameters?.recordId;
    if (recordId === null || recordId === undefined) {
      throw new Error('Required parameter recordId was null or undefined when calling getByIdRecords.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/records/${this.configuration.encodeParam({ name: 'recordId', value: recordId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsRecordsRecordModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetEmployeeSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>;
  public getEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetEmployeeSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>>;
  public getEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetEmployeeSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>>;
  public getEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetEmployeeSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const snapshotId = requestParameters?.snapshotId;
    if (snapshotId === null || snapshotId === undefined) {
      throw new Error('Required parameter snapshotId was null or undefined when calling getEmployeeSnapshots.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/employee-snapshots/${this.configuration.encodeParam({ name: 'snapshotId', value: snapshotId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetInformationFieldValuesOrganisationInformationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public getInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetInformationFieldValuesOrganisationInformationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public getInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetInformationFieldValuesOrganisationInformationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public getInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetInformationFieldValuesOrganisationInformationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling getInformationFieldValuesOrganisationInformationSnapshots.'
      );
    }
    const targetProperty = requestParameters?.targetProperty;
    const orgCode = requestParameters?.orgCode;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information/field-values`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetMembersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsMembersMemberModel>;
  public getMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetMembersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsMembersMemberModel>>;
  public getMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetMembersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsMembersMemberModel>>;
  public getMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetMembersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getMembers.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/members/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsMembersMemberModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMySeasonRecordsSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetMySeasonRecordsSeasonsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsRecordsRecordModel>;
  public getMySeasonRecordsSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetMySeasonRecordsSeasonsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsRecordsRecordModel>>;
  public getMySeasonRecordsSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetMySeasonRecordsSeasonsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsRecordsRecordModel>>;
  public getMySeasonRecordsSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetMySeasonRecordsSeasonsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getMySeasonRecordsSeasons.');
    }
    const memberId = requestParameters?.memberId;
    const gid = requestParameters?.gid;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (memberId !== undefined && memberId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>memberId, 'memberId');
    }
    if (gid !== undefined && gid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>gid, 'gid');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/myrecords`;
    return this.httpClient.request<SharedPageModelOfSeasonsRecordsRecordModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getOfSeasonPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetOfSeasonPublicationSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsPublicationSettingsPublicationSettingsModel>;
  public getOfSeasonPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetOfSeasonPublicationSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsPublicationSettingsPublicationSettingsModel>>;
  public getOfSeasonPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetOfSeasonPublicationSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsPublicationSettingsPublicationSettingsModel>>;
  public getOfSeasonPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetOfSeasonPublicationSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling getOfSeasonPublicationSettings.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publication-settings`;
    return this.httpClient.request<SeasonsPublicationSettingsPublicationSettingsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetOrganisationInformationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>;
  public getOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetOrganisationInformationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>>;
  public getOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetOrganisationInformationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>>;
  public getOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetOrganisationInformationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getOrganisationInformationSnapshots.');
    }
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling getOrganisationInformationSnapshots.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/snapshots/organisations/information/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetOrganisationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsOrganisationSnapshotsOrganisationSnapshotModel>;
  public getOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetOrganisationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsOrganisationSnapshotsOrganisationSnapshotModel>>;
  public getOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetOrganisationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsOrganisationSnapshotsOrganisationSnapshotModel>>;
  public getOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetOrganisationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling getOrganisationSnapshots.');
    }
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getOrganisationSnapshots.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsOrganisationSnapshotsOrganisationSnapshotModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPlanPopulationPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetPlanPopulationPlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsMembersMemberModel>;
  public getPlanPopulationPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetPlanPopulationPlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsMembersMemberModel>>;
  public getPlanPopulationPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetPlanPopulationPlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsMembersMemberModel>>;
  public getPlanPopulationPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetPlanPopulationPlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getPlanPopulationPlans.');
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/members`;
    return this.httpClient.request<SharedPageModelOfSeasonsMembersMemberModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPlanRecordsPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetPlanRecordsPlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsRecordsRecordModel>;
  public getPlanRecordsPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetPlanRecordsPlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsRecordsRecordModel>>;
  public getPlanRecordsPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetPlanRecordsPlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsRecordsRecordModel>>;
  public getPlanRecordsPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetPlanRecordsPlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getPlanRecordsPlans.');
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records`;
    return this.httpClient.request<SharedPageModelOfSeasonsRecordsRecordModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetPlanSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsPlanSettingsPlanSettingsModel>;
  public getPlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetPlanSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsPlanSettingsPlanSettingsModel>>;
  public getPlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetPlanSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsPlanSettingsPlanSettingsModel>>;
  public getPlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetPlanSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const planId = requestParameters?.planId;
    if (planId === null || planId === undefined) {
      throw new Error('Required parameter planId was null or undefined when calling getPlanSettings.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings`;
    return this.httpClient.request<SeasonsPlanSettingsPlanSettingsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetPlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsPlansPlanModel>;
  public getPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetPlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsPlansPlanModel>>;
  public getPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetPlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsPlansPlanModel>>;
  public getPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetPlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getPlans.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsPlansPlanModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetPublicationSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsPublicationSettingsPublicationSettingsModel>;
  public getPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetPublicationSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsPublicationSettingsPublicationSettingsModel>>;
  public getPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetPublicationSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsPublicationSettingsPublicationSettingsModel>>;
  public getPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetPublicationSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getPublicationSettings.');
    }
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling getPublicationSettings.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/publication-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsPublicationSettingsPublicationSettingsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Search for record models based on given query parameters
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getRecords(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetRecordsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsRecordsRecordModel>;
  public getRecords(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetRecordsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsRecordsRecordModel>>;
  public getRecords(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetRecordsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsRecordsRecordModel>>;
  public getRecords(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetRecordsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling getRecords.');
    }
    const memberId = requestParameters?.memberId;
    const gid = requestParameters?.gid;
    const firstName = requestParameters?.firstName;
    const lastName = requestParameters?.lastName;
    const country = requestParameters?.country;
    const are = requestParameters?.are;
    const orgCode = requestParameters?.orgCode;
    const state = requestParameters?.state;
    const planName = requestParameters?.planName;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    const assignmentId = requestParameters?.assignmentId;
    const isDesignReady = requestParameters?.isDesignReady;
    const letterState = requestParameters?.letterState;
    const payoutState = requestParameters?.payoutState;
    const template = requestParameters?.template;
    const workflow = requestParameters?.workflow;
    const seasonId2 = requestParameters?.seasonId2;
    const workflowInstanceState = requestParameters?.workflowInstanceState;
    const lineManagerName = requestParameters?.lineManagerName;
    const lineManagerGid = requestParameters?.lineManagerGid;
    const lineManagerPositionClass = requestParameters?.lineManagerPositionClass;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (memberId !== undefined && memberId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>memberId, 'MemberId');
    }
    if (gid) {
      gid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Gid');
      });
    }
    if (firstName) {
      firstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'FirstName');
      });
    }
    if (lastName) {
      lastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LastName');
      });
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (are) {
      are.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Are');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (state) {
      state.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'State');
      });
    }
    if (planName) {
      planName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PlanName');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (assignmentId !== undefined && assignmentId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>assignmentId, 'AssignmentId');
    }
    if (isDesignReady !== undefined && isDesignReady !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isDesignReady, 'IsDesignReady');
    }
    if (letterState) {
      letterState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LetterState');
      });
    }
    if (payoutState) {
      payoutState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PayoutState');
      });
    }
    if (template !== undefined && template !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>template, 'Template');
    }
    if (workflow !== undefined && workflow !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>workflow, 'Workflow');
    }
    if (seasonId2 !== undefined && seasonId2 !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId2, 'SeasonId');
    }
    if (workflowInstanceState) {
      workflowInstanceState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkflowInstanceState');
      });
    }
    if (lineManagerName !== undefined && lineManagerName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>lineManagerName, 'LineManagerName');
    }
    if (lineManagerGid) {
      lineManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LineManagerGid');
      });
    }
    if (lineManagerPositionClass !== undefined && lineManagerPositionClass !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>lineManagerPositionClass,
        'LineManagerPositionClass'
      );
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/records/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SharedPageModelOfSeasonsRecordsRecordModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSeasonCommunicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSeasonCommunicationSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<MeritCommunicationSettingsMeritCommunicationSettingsModel>;
  public getSeasonCommunicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSeasonCommunicationSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<MeritCommunicationSettingsMeritCommunicationSettingsModel>>;
  public getSeasonCommunicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSeasonCommunicationSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<MeritCommunicationSettingsMeritCommunicationSettingsModel>>;
  public getSeasonCommunicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSeasonCommunicationSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling getSeasonCommunicationSettings.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/communication-settings`;
    return this.httpClient.request<MeritCommunicationSettingsMeritCommunicationSettingsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSeasonOverviewForEmployeeMembersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsMembersEmployeeSeasonOverviewModel>;
  public getSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSeasonOverviewForEmployeeMembersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsMembersEmployeeSeasonOverviewModel>>;
  public getSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSeasonOverviewForEmployeeMembersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsMembersEmployeeSeasonOverviewModel>>;
  public getSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSeasonOverviewForEmployeeMembersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const gid = requestParameters?.gid;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (gid !== undefined && gid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>gid, 'gid');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/members/overview`;
    return this.httpClient.request<SeasonsMembersEmployeeSeasonOverviewModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSeasonRecordsSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSeasonRecordsSeasonsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsRecordsRecordModel>;
  public getSeasonRecordsSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSeasonRecordsSeasonsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsRecordsRecordModel>>;
  public getSeasonRecordsSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSeasonRecordsSeasonsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsRecordsRecordModel>>;
  public getSeasonRecordsSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSeasonRecordsSeasonsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getSeasonRecordsSeasons.');
    }
    const queryId = requestParameters?.queryId;
    const queryGid = requestParameters?.queryGid;
    const queryFirstName = requestParameters?.queryFirstName;
    const queryLastName = requestParameters?.queryLastName;
    const queryCountry = requestParameters?.queryCountry;
    const queryAre = requestParameters?.queryAre;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryOrgClusterNodeName = requestParameters?.queryOrgClusterNodeName;
    const queryState = requestParameters?.queryState;
    const queryPlanName = requestParameters?.queryPlanName;
    const queryStartDate = requestParameters?.queryStartDate;
    const queryEndDate = requestParameters?.queryEndDate;
    const queryAssignmentId = requestParameters?.queryAssignmentId;
    const queryLetterType = requestParameters?.queryLetterType;
    const queryProcessStates = requestParameters?.queryProcessStates;
    const queryRecordCommunicationStates = requestParameters?.queryRecordCommunicationStates;
    const queryWorkflow = requestParameters?.queryWorkflow;
    const queryTemplate = requestParameters?.queryTemplate;
    const queryIsDesignReady = requestParameters?.queryIsDesignReady;
    const queryPayoutDate = requestParameters?.queryPayoutDate;
    const queryPayoutState = requestParameters?.queryPayoutState;
    const queryLineManagerName = requestParameters?.queryLineManagerName;
    const queryLineManagerGid = requestParameters?.queryLineManagerGid;
    const querySeasonId = requestParameters?.querySeasonId;
    const queryWorkflowInstanceState = requestParameters?.queryWorkflowInstanceState;
    const queryMultiplier = requestParameters?.queryMultiplier;
    const queryOverallTargetAchievement = requestParameters?.queryOverallTargetAchievement;
    const queryPayoutAmount = requestParameters?.queryPayoutAmount;
    const queryPayoutCurrency = requestParameters?.queryPayoutCurrency;
    const queryIppAchievementValue = requestParameters?.queryIppAchievementValue;
    const queryIncentivePaymentType = requestParameters?.queryIncentivePaymentType;
    const queryContractStatus = requestParameters?.queryContractStatus;
    const queryMeasurementDate = requestParameters?.queryMeasurementDate;
    const queryMeritTitle = requestParameters?.queryMeritTitle;
    const queryEquityTitle = requestParameters?.queryEquityTitle;
    const queryEquitySubTitle = requestParameters?.queryEquitySubTitle;
    const queryManuallyChanged = requestParameters?.queryManuallyChanged;
    const queryNewHire = requestParameters?.queryNewHire;
    const queryPromotion = requestParameters?.queryPromotion;
    const queryTermination = requestParameters?.queryTermination;
    const queryPopulationChange = requestParameters?.queryPopulationChange;
    const queryLineManagerFirstName = requestParameters?.queryLineManagerFirstName;
    const queryLineManagerLastName = requestParameters?.queryLineManagerLastName;
    const queryCompanyManagerFirstName = requestParameters?.queryCompanyManagerFirstName;
    const queryCompanyManagerGid = requestParameters?.queryCompanyManagerGid;
    const queryCompanyManagerLastName = requestParameters?.queryCompanyManagerLastName;
    const queryTemplateName = requestParameters?.queryTemplateName;
    const queryWorkflowType = requestParameters?.queryWorkflowType;
    const queryAutoApprove = requestParameters?.queryAutoApprove;
    const queryApprovalRequired = requestParameters?.queryApprovalRequired;
    const queryLetterState = requestParameters?.queryLetterState;
    const queryProcessState = requestParameters?.queryProcessState;
    const queryExportState = requestParameters?.queryExportState;
    const queryPayrollState = requestParameters?.queryPayrollState;
    const queryMeritRelevancy = requestParameters?.queryMeritRelevancy;
    const queryApprovedByCompanyManager = requestParameters?.queryApprovedByCompanyManager;
    const queryAllocationWorkflowType = requestParameters?.queryAllocationWorkflowType;
    const queryReadyToPayroll = requestParameters?.queryReadyToPayroll;
    const queryEquityRelevancy = requestParameters?.queryEquityRelevancy;
    const queryHasOtpIncrease = requestParameters?.queryHasOtpIncrease;
    const queryIsOtpOnly = requestParameters?.queryIsOtpOnly;
    const queryPlanTitle = requestParameters?.queryPlanTitle;
    const queryLocalCurrency = requestParameters?.queryLocalCurrency;
    const queryProposalAmount = requestParameters?.queryProposalAmount;
    const queryProposalAmountInEuro = requestParameters?.queryProposalAmountInEuro;
    const queryProposalDate = requestParameters?.queryProposalDate;
    const queryProposalState = requestParameters?.queryProposalState;
    const querySpecialPaymentReason = requestParameters?.querySpecialPaymentReason;
    const querySpecialPaymentCompensationType = requestParameters?.querySpecialPaymentCompensationType;
    const queryTemplateLetterName = requestParameters?.queryTemplateLetterName;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryId) {
      queryId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Id');
      });
    }
    if (queryGid) {
      queryGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Gid');
      });
    }
    if (queryFirstName) {
      queryFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.FirstName');
      });
    }
    if (queryLastName) {
      queryLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LastName');
      });
    }
    if (queryCountry) {
      queryCountry.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Country');
      });
    }
    if (queryAre) {
      queryAre.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Are');
      });
    }
    if (queryOrgCode) {
      queryOrgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgCode');
      });
    }
    if (queryOrgClusterNodeName) {
      queryOrgClusterNodeName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.OrgClusterNodeName'
        );
      });
    }
    if (queryState) {
      queryState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.State');
      });
    }
    if (queryPlanName) {
      queryPlanName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PlanName');
      });
    }
    if (queryStartDate !== undefined && queryStartDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryStartDate, 'Query.StartDate');
    }
    if (queryEndDate !== undefined && queryEndDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryEndDate, 'Query.EndDate');
    }
    if (queryAssignmentId !== undefined && queryAssignmentId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAssignmentId,
        'Query.AssignmentId'
      );
    }
    if (queryLetterType !== undefined && queryLetterType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryLetterType, 'Query.LetterType');
    }
    if (queryProcessStates) {
      queryProcessStates.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ProcessStates');
      });
    }
    if (queryRecordCommunicationStates) {
      queryRecordCommunicationStates.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.RecordCommunicationStates'
        );
      });
    }
    if (queryWorkflow) {
      queryWorkflow.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Workflow');
      });
    }
    if (queryTemplate) {
      queryTemplate.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Template');
      });
    }
    if (queryIsDesignReady !== undefined && queryIsDesignReady !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryIsDesignReady,
        'Query.IsDesignReady'
      );
    }
    if (queryPayoutDate !== undefined && queryPayoutDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryPayoutDate, 'Query.PayoutDate');
    }
    if (queryPayoutState) {
      queryPayoutState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PayoutState');
      });
    }
    if (queryLineManagerName !== undefined && queryLineManagerName !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryLineManagerName,
        'Query.LineManagerName'
      );
    }
    if (queryLineManagerGid) {
      queryLineManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LineManagerGid');
      });
    }
    if (querySeasonId !== undefined && querySeasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>querySeasonId, 'Query.SeasonId');
    }
    if (queryWorkflowInstanceState) {
      queryWorkflowInstanceState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.WorkflowInstanceState'
        );
      });
    }
    if (queryMultiplier !== undefined && queryMultiplier !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryMultiplier, 'Query.Multiplier');
    }
    if (queryOverallTargetAchievement !== undefined && queryOverallTargetAchievement !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryOverallTargetAchievement,
        'Query.OverallTargetAchievement'
      );
    }
    if (queryPayoutAmount !== undefined && queryPayoutAmount !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryPayoutAmount,
        'Query.PayoutAmount'
      );
    }
    if (queryPayoutCurrency) {
      queryPayoutCurrency.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PayoutCurrency');
      });
    }
    if (queryIppAchievementValue !== undefined && queryIppAchievementValue !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryIppAchievementValue,
        'Query.IppAchievementValue'
      );
    }
    if (queryIncentivePaymentType) {
      queryIncentivePaymentType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncentivePaymentType'
        );
      });
    }
    if (queryContractStatus) {
      queryContractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ContractStatus');
      });
    }
    if (queryMeasurementDate !== undefined && queryMeasurementDate !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryMeasurementDate,
        'Query.MeasurementDate'
      );
    }
    if (queryMeritTitle) {
      queryMeritTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.MeritTitle');
      });
    }
    if (queryEquityTitle) {
      queryEquityTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.EquityTitle');
      });
    }
    if (queryEquitySubTitle) {
      queryEquitySubTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.EquitySubTitle');
      });
    }
    if (queryManuallyChanged) {
      queryManuallyChanged.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ManuallyChanged');
      });
    }
    if (queryNewHire) {
      queryNewHire.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.NewHire');
      });
    }
    if (queryPromotion) {
      queryPromotion.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Promotion');
      });
    }
    if (queryTermination) {
      queryTermination.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Termination');
      });
    }
    if (queryPopulationChange) {
      queryPopulationChange.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PopulationChange');
      });
    }
    if (queryLineManagerFirstName) {
      queryLineManagerFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.LineManagerFirstName'
        );
      });
    }
    if (queryLineManagerLastName) {
      queryLineManagerLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.LineManagerLastName'
        );
      });
    }
    if (queryCompanyManagerFirstName) {
      queryCompanyManagerFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.CompanyManagerFirstName'
        );
      });
    }
    if (queryCompanyManagerGid) {
      queryCompanyManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.CompanyManagerGid'
        );
      });
    }
    if (queryCompanyManagerLastName) {
      queryCompanyManagerLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.CompanyManagerLastName'
        );
      });
    }
    if (queryTemplateName) {
      queryTemplateName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.TemplateName');
      });
    }
    if (queryWorkflowType) {
      queryWorkflowType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.WorkflowType');
      });
    }
    if (queryAutoApprove !== undefined && queryAutoApprove !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAutoApprove,
        'Query.AutoApprove'
      );
    }
    if (queryApprovalRequired !== undefined && queryApprovalRequired !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryApprovalRequired,
        'Query.ApprovalRequired'
      );
    }
    if (queryLetterState) {
      queryLetterState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LetterState');
      });
    }
    if (queryProcessState) {
      queryProcessState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ProcessState');
      });
    }
    if (queryExportState) {
      queryExportState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ExportState');
      });
    }
    if (queryPayrollState) {
      queryPayrollState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PayrollState');
      });
    }
    if (queryMeritRelevancy) {
      queryMeritRelevancy.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.MeritRelevancy');
      });
    }
    if (queryApprovedByCompanyManager !== undefined && queryApprovedByCompanyManager !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryApprovedByCompanyManager,
        'Query.ApprovedByCompanyManager'
      );
    }
    if (queryAllocationWorkflowType) {
      queryAllocationWorkflowType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.AllocationWorkflowType'
        );
      });
    }
    if (queryReadyToPayroll !== undefined && queryReadyToPayroll !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryReadyToPayroll,
        'Query.ReadyToPayroll'
      );
    }
    if (queryEquityRelevancy) {
      queryEquityRelevancy.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.EquityRelevancy');
      });
    }
    if (queryHasOtpIncrease !== undefined && queryHasOtpIncrease !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHasOtpIncrease,
        'Query.HasOtpIncrease'
      );
    }
    if (queryIsOtpOnly !== undefined && queryIsOtpOnly !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryIsOtpOnly, 'Query.IsOtpOnly');
    }
    if (queryPlanTitle) {
      queryPlanTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PlanTitle');
      });
    }
    if (queryLocalCurrency) {
      queryLocalCurrency.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LocalCurrency');
      });
    }
    if (queryProposalAmount !== undefined && queryProposalAmount !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryProposalAmount,
        'Query.ProposalAmount'
      );
    }
    if (queryProposalAmountInEuro !== undefined && queryProposalAmountInEuro !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryProposalAmountInEuro,
        'Query.ProposalAmountInEuro'
      );
    }
    if (queryProposalDate !== undefined && queryProposalDate !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryProposalDate,
        'Query.ProposalDate'
      );
    }
    if (queryProposalState) {
      queryProposalState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ProposalState');
      });
    }
    if (querySpecialPaymentReason) {
      querySpecialPaymentReason.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.SpecialPaymentReason'
        );
      });
    }
    if (querySpecialPaymentCompensationType) {
      querySpecialPaymentCompensationType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.SpecialPaymentCompensationType'
        );
      });
    }
    if (queryTemplateLetterName) {
      queryTemplateLetterName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.TemplateLetterName'
        );
      });
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records`;
    return this.httpClient.request<SharedPageModelOfSeasonsRecordsRecordModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSeasonSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSeasonSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsSettingsSeasonSettingsModel>;
  public getSeasonSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSeasonSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsSettingsSeasonSettingsModel>>;
  public getSeasonSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSeasonSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsSettingsSeasonSettingsModel>>;
  public getSeasonSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSeasonSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling getSeasonSettings.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/settings/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsSettingsSeasonSettingsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSeasonsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsSeasonsSeasonModel>;
  public getSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSeasonsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsSeasonsSeasonModel>>;
  public getSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSeasonsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsSeasonsSeasonModel>>;
  public getSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSeasonsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getSeasons.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsSeasonsSeasonModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSimulationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<PositionEvaluationSimulationsPositionEvaluationSimulationModel>>;
  public getSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSimulationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<PositionEvaluationSimulationsPositionEvaluationSimulationModel>>>;
  public getSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSimulationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<PositionEvaluationSimulationsPositionEvaluationSimulationModel>>>;
  public getSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSimulationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error('Required parameter simulationId was null or undefined when calling getSimulation.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<Array<PositionEvaluationSimulationsPositionEvaluationSimulationModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSnapshotSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSnapshotSeasonsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsSnapshotsSnapshotModel>;
  public getSnapshotSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSnapshotSeasonsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsSnapshotsSnapshotModel>>;
  public getSnapshotSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSnapshotSeasonsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsSnapshotsSnapshotModel>>;
  public getSnapshotSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetSnapshotSeasonsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getSnapshotSeasons.');
    }
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error('Required parameter employeeId was null or undefined when calling getSnapshotSeasons.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsSnapshotsSnapshotModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTreeOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetTreeOrganisationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<SeasonsOrganisationSnapshotsOrganisationSnapshotTreeItemModel>>;
  public getTreeOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetTreeOrganisationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<SeasonsOrganisationSnapshotsOrganisationSnapshotTreeItemModel>>>;
  public getTreeOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetTreeOrganisationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<SeasonsOrganisationSnapshotsOrganisationSnapshotTreeItemModel>>>;
  public getTreeOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceGetTreeOrganisationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling getTreeOrganisationSnapshots.');
    }
    const parentOrgCode = requestParameters?.parentOrgCode;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (parentOrgCode !== undefined && parentOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>parentOrgCode, 'parentOrgCode');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/tree`;
    return this.httpClient.request<Array<SeasonsOrganisationSnapshotsOrganisationSnapshotTreeItemModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public partialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServicePartialUpdateEmployeeSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>;
  public partialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServicePartialUpdateEmployeeSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>>;
  public partialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServicePartialUpdateEmployeeSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>>;
  public partialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServicePartialUpdateEmployeeSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const snapshotId = requestParameters?.snapshotId;
    if (snapshotId === null || snapshotId === undefined) {
      throw new Error(
        'Required parameter snapshotId was null or undefined when calling partialUpdateEmployeeSnapshots.'
      );
    }
    const seasonsEmployeeSnapshotsUpdateEmployeeSnapshotPartialModel =
      requestParameters?.seasonsEmployeeSnapshotsUpdateEmployeeSnapshotPartialModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/employee-snapshots/${this.configuration.encodeParam({ name: 'snapshotId', value: snapshotId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsEmployeeSnapshotsUpdateEmployeeSnapshotPartialModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public prePublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminServicePrePublishSimulationPublicationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public prePublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminServicePrePublishSimulationPublicationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public prePublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminServicePrePublishSimulationPublicationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public prePublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminServicePrePublishSimulationPublicationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling prePublishSimulationPublications.'
      );
    }
    const positionName = requestParameters?.positionName;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const orgLevel = requestParameters?.orgLevel;
    const orgSize = requestParameters?.orgSize;
    const mercerJobCode = requestParameters?.mercerJobCode;
    const positionClass = requestParameters?.positionClass;
    const newPositionClass = requestParameters?.newPositionClass;
    const originalProposedPositionClass = requestParameters?.originalProposedPositionClass;
    const positionType = requestParameters?.positionType;
    const countryIsoCode = requestParameters?.countryIsoCode;
    const incumbentGid = requestParameters?.incumbentGid;
    const incumbentFirstName = requestParameters?.incumbentFirstName;
    const incumbentLastName = requestParameters?.incumbentLastName;
    const incumbentCountryPlaceOfAction = requestParameters?.incumbentCountryPlaceOfAction;
    const validationManagerId = requestParameters?.validationManagerId;
    const validationManagerGid = requestParameters?.validationManagerGid;
    const validationManagerFirstName = requestParameters?.validationManagerFirstName;
    const validationManagerLastName = requestParameters?.validationManagerLastName;
    const validationState = requestParameters?.validationState;
    const placementState = requestParameters?.placementState;
    const newHireState = requestParameters?.newHireState;
    const isLocked = requestParameters?.isLocked;
    const mercerJobFamily = requestParameters?.mercerJobFamily;
    const mercerJobSpecialization = requestParameters?.mercerJobSpecialization;
    const mercerJobSubFamily = requestParameters?.mercerJobSubFamily;
    const incumbentAre = requestParameters?.incumbentAre;
    const tag = requestParameters?.tag;
    const wasPromoted = requestParameters?.wasPromoted;
    const isTransferred = requestParameters?.isTransferred;
    const seasonsSimulationPublicationsPublishSimulationModel =
      requestParameters?.seasonsSimulationPublicationsPublishSimulationModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (positionName) {
      positionName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionName');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith) {
      orgCodeStartsWith.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCodeStartsWith');
      });
    }
    if (orgLevel) {
      orgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgLevel');
      });
    }
    if (orgSize) {
      orgSize.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgSize');
      });
    }
    if (mercerJobCode) {
      mercerJobCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobCode');
      });
    }
    if (positionClass) {
      positionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionClass');
      });
    }
    if (newPositionClass) {
      newPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'NewPositionClass');
      });
    }
    if (originalProposedPositionClass) {
      originalProposedPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'OriginalProposedPositionClass'
        );
      });
    }
    if (positionType) {
      positionType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionType');
      });
    }
    if (countryIsoCode) {
      countryIsoCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryIsoCode');
      });
    }
    if (incumbentGid) {
      incumbentGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IncumbentGid');
      });
    }
    if (incumbentFirstName) {
      incumbentFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IncumbentFirstName');
      });
    }
    if (incumbentLastName) {
      incumbentLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IncumbentLastName');
      });
    }
    if (incumbentCountryPlaceOfAction) {
      incumbentCountryPlaceOfAction.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'IncumbentCountryPlaceOfAction'
        );
      });
    }
    if (validationManagerId) {
      validationManagerId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ValidationManagerId');
      });
    }
    if (validationManagerGid) {
      validationManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ValidationManagerGid');
      });
    }
    if (validationManagerFirstName) {
      validationManagerFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'ValidationManagerFirstName'
        );
      });
    }
    if (validationManagerLastName) {
      validationManagerLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'ValidationManagerLastName'
        );
      });
    }
    if (validationState) {
      validationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ValidationState');
      });
    }
    if (placementState) {
      placementState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PlacementState');
      });
    }
    if (newHireState) {
      newHireState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'NewHireState');
      });
    }
    if (isLocked) {
      isLocked.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IsLocked');
      });
    }
    if (mercerJobFamily) {
      mercerJobFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobFamily');
      });
    }
    if (mercerJobSpecialization) {
      mercerJobSpecialization.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'MercerJobSpecialization'
        );
      });
    }
    if (mercerJobSubFamily) {
      mercerJobSubFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobSubFamily');
      });
    }
    if (incumbentAre) {
      incumbentAre.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IncumbentAre');
      });
    }
    if (tag) {
      tag.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Tag');
      });
    }
    if (wasPromoted) {
      wasPromoted.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WasPromoted');
      });
    }
    if (isTransferred) {
      isTransferred.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IsTransferred');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/pre-publish`;
    return this.httpClient.request<TransactionStatusOfSimulationPublishMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSimulationPublicationsPublishSimulationModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public publishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminServicePublishSimulationPublicationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public publishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminServicePublishSimulationPublicationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public publishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminServicePublishSimulationPublicationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public publishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminServicePublishSimulationPublicationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling publishSimulationPublications.'
      );
    }
    const queryPositionName = requestParameters?.queryPositionName;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryOrgCodeStartsWith = requestParameters?.queryOrgCodeStartsWith;
    const queryOrgLevel = requestParameters?.queryOrgLevel;
    const queryOrgSize = requestParameters?.queryOrgSize;
    const queryMercerJobCode = requestParameters?.queryMercerJobCode;
    const queryPositionClass = requestParameters?.queryPositionClass;
    const queryNewPositionClass = requestParameters?.queryNewPositionClass;
    const queryOriginalProposedPositionClass = requestParameters?.queryOriginalProposedPositionClass;
    const queryPositionType = requestParameters?.queryPositionType;
    const queryCountryIsoCode = requestParameters?.queryCountryIsoCode;
    const queryIncumbentGid = requestParameters?.queryIncumbentGid;
    const queryIncumbentFirstName = requestParameters?.queryIncumbentFirstName;
    const queryIncumbentLastName = requestParameters?.queryIncumbentLastName;
    const queryIncumbentCountryPlaceOfAction = requestParameters?.queryIncumbentCountryPlaceOfAction;
    const queryValidationManagerId = requestParameters?.queryValidationManagerId;
    const queryValidationManagerGid = requestParameters?.queryValidationManagerGid;
    const queryValidationManagerFirstName = requestParameters?.queryValidationManagerFirstName;
    const queryValidationManagerLastName = requestParameters?.queryValidationManagerLastName;
    const queryValidationState = requestParameters?.queryValidationState;
    const queryPlacementState = requestParameters?.queryPlacementState;
    const queryNewHireState = requestParameters?.queryNewHireState;
    const queryIsLocked = requestParameters?.queryIsLocked;
    const queryMercerJobFamily = requestParameters?.queryMercerJobFamily;
    const queryMercerJobSpecialization = requestParameters?.queryMercerJobSpecialization;
    const queryMercerJobSubFamily = requestParameters?.queryMercerJobSubFamily;
    const queryIncumbentAre = requestParameters?.queryIncumbentAre;
    const queryTag = requestParameters?.queryTag;
    const queryWasPromoted = requestParameters?.queryWasPromoted;
    const queryIsTransferred = requestParameters?.queryIsTransferred;
    const seasonsSimulationPublicationsPublishSimulationModel =
      requestParameters?.seasonsSimulationPublicationsPublishSimulationModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryPositionName) {
      queryPositionName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PositionName');
      });
    }
    if (queryOrgCode) {
      queryOrgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgCode');
      });
    }
    if (queryOrgCodeStartsWith) {
      queryOrgCodeStartsWith.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.OrgCodeStartsWith'
        );
      });
    }
    if (queryOrgLevel) {
      queryOrgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgLevel');
      });
    }
    if (queryOrgSize) {
      queryOrgSize.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgSize');
      });
    }
    if (queryMercerJobCode) {
      queryMercerJobCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.MercerJobCode');
      });
    }
    if (queryPositionClass) {
      queryPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PositionClass');
      });
    }
    if (queryNewPositionClass) {
      queryNewPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.NewPositionClass');
      });
    }
    if (queryOriginalProposedPositionClass) {
      queryOriginalProposedPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.OriginalProposedPositionClass'
        );
      });
    }
    if (queryPositionType) {
      queryPositionType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PositionType');
      });
    }
    if (queryCountryIsoCode) {
      queryCountryIsoCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.CountryIsoCode');
      });
    }
    if (queryIncumbentGid) {
      queryIncumbentGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IncumbentGid');
      });
    }
    if (queryIncumbentFirstName) {
      queryIncumbentFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncumbentFirstName'
        );
      });
    }
    if (queryIncumbentLastName) {
      queryIncumbentLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncumbentLastName'
        );
      });
    }
    if (queryIncumbentCountryPlaceOfAction) {
      queryIncumbentCountryPlaceOfAction.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncumbentCountryPlaceOfAction'
        );
      });
    }
    if (queryValidationManagerId) {
      queryValidationManagerId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerId'
        );
      });
    }
    if (queryValidationManagerGid) {
      queryValidationManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerGid'
        );
      });
    }
    if (queryValidationManagerFirstName) {
      queryValidationManagerFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerFirstName'
        );
      });
    }
    if (queryValidationManagerLastName) {
      queryValidationManagerLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerLastName'
        );
      });
    }
    if (queryValidationState) {
      queryValidationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ValidationState');
      });
    }
    if (queryPlacementState) {
      queryPlacementState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PlacementState');
      });
    }
    if (queryNewHireState) {
      queryNewHireState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.NewHireState');
      });
    }
    if (queryIsLocked) {
      queryIsLocked.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IsLocked');
      });
    }
    if (queryMercerJobFamily) {
      queryMercerJobFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.MercerJobFamily');
      });
    }
    if (queryMercerJobSpecialization) {
      queryMercerJobSpecialization.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.MercerJobSpecialization'
        );
      });
    }
    if (queryMercerJobSubFamily) {
      queryMercerJobSubFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.MercerJobSubFamily'
        );
      });
    }
    if (queryIncumbentAre) {
      queryIncumbentAre.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IncumbentAre');
      });
    }
    if (queryTag) {
      queryTag.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Tag');
      });
    }
    if (queryWasPromoted) {
      queryWasPromoted.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.WasPromoted');
      });
    }
    if (queryIsTransferred) {
      queryIsTransferred.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IsTransferred');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publish`;
    return this.httpClient.request<TransactionStatusOfSimulationPublishMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSimulationPublicationsPublishSimulationModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryCandidatePoolsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<SeasonsCandidatePoolsCandidatePoolModel>>;
  public queryCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryCandidatePoolsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<SeasonsCandidatePoolsCandidatePoolModel>>>;
  public queryCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryCandidatePoolsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<SeasonsCandidatePoolsCandidatePoolModel>>>;
  public queryCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryCandidatePoolsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'seasonId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/candidate-pools`;
    return this.httpClient.request<Array<SeasonsCandidatePoolsCandidatePoolModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryEmployeeCandidatesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfPositionEvaluationEmployeeCandidatesPositionEvaluationCandidateModel>;
  public queryEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryEmployeeCandidatesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfPositionEvaluationEmployeeCandidatesPositionEvaluationCandidateModel>>;
  public queryEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryEmployeeCandidatesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfPositionEvaluationEmployeeCandidatesPositionEvaluationCandidateModel>>;
  public queryEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryEmployeeCandidatesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const queryGid = requestParameters?.queryGid;
    const queryFirstname = requestParameters?.queryFirstname;
    const queryLastname = requestParameters?.queryLastname;
    const queryPAOrgCode = requestParameters?.queryPAOrgCode;
    const queryCandidatePoolTitle = requestParameters?.queryCandidatePoolTitle;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryGender = requestParameters?.queryGender;
    const queryOrgLevel = requestParameters?.queryOrgLevel;
    const queryMercerPositionClass = requestParameters?.queryMercerPositionClass;
    const queryIsPlaced = requestParameters?.queryIsPlaced;
    const queryIsShortlisted = requestParameters?.queryIsShortlisted;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }
    if (queryGid !== undefined && queryGid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryGid, 'Query.Gid');
    }
    if (queryFirstname !== undefined && queryFirstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryFirstname, 'Query.Firstname');
    }
    if (queryLastname !== undefined && queryLastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryLastname, 'Query.Lastname');
    }
    if (queryPAOrgCode) {
      queryPAOrgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PAOrgCode');
      });
    }
    if (queryCandidatePoolTitle) {
      queryCandidatePoolTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.CandidatePoolTitle'
        );
      });
    }
    if (queryOrgCode !== undefined && queryOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgCode, 'Query.OrgCode');
    }
    if (queryGender) {
      queryGender.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Gender');
      });
    }
    if (queryOrgLevel) {
      queryOrgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgLevel');
      });
    }
    if (queryMercerPositionClass) {
      queryMercerPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.MercerPositionClass'
        );
      });
    }
    if (queryIsPlaced !== undefined && queryIsPlaced !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryIsPlaced, 'Query.IsPlaced');
    }
    if (queryIsShortlisted !== undefined && queryIsShortlisted !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryIsShortlisted,
        'Query.IsShortlisted'
      );
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/employee-candidates`;
    return this.httpClient.request<SharedPageModelOfPositionEvaluationEmployeeCandidatesPositionEvaluationCandidateModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryEmployeeSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsEmployeeSnapshotsEmployeeSnapshotModel>;
  public queryEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryEmployeeSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsEmployeeSnapshotsEmployeeSnapshotModel>>;
  public queryEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryEmployeeSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsEmployeeSnapshotsEmployeeSnapshotModel>>;
  public queryEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryEmployeeSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/employee-snapshots`;
    return this.httpClient.request<SharedPageModelOfSeasonsEmployeeSnapshotsEmployeeSnapshotModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryFieldValuesEmployeeCandidatesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public queryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryFieldValuesEmployeeCandidatesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public queryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryFieldValuesEmployeeCandidatesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public queryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryFieldValuesEmployeeCandidatesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    const seasonId = requestParameters?.seasonId;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const gid = requestParameters?.gid;
    const firstname = requestParameters?.firstname;
    const lastname = requestParameters?.lastname;
    const pAOrgCode = requestParameters?.pAOrgCode;
    const candidatePoolTitle = requestParameters?.candidatePoolTitle;
    const orgCode = requestParameters?.orgCode;
    const gender = requestParameters?.gender;
    const orgLevel = requestParameters?.orgLevel;
    const mercerPositionClass = requestParameters?.mercerPositionClass;
    const isPlaced = requestParameters?.isPlaced;
    const isShortlisted = requestParameters?.isShortlisted;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (gid !== undefined && gid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>gid, 'Gid');
    }
    if (firstname !== undefined && firstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>firstname, 'Firstname');
    }
    if (lastname !== undefined && lastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>lastname, 'Lastname');
    }
    if (pAOrgCode) {
      pAOrgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PAOrgCode');
      });
    }
    if (candidatePoolTitle) {
      candidatePoolTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CandidatePoolTitle');
      });
    }
    if (orgCode !== undefined && orgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgCode, 'OrgCode');
    }
    if (gender) {
      gender.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Gender');
      });
    }
    if (orgLevel) {
      orgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgLevel');
      });
    }
    if (mercerPositionClass) {
      mercerPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerPositionClass');
      });
    }
    if (isPlaced !== undefined && isPlaced !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isPlaced, 'IsPlaced');
    }
    if (isShortlisted !== undefined && isShortlisted !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isShortlisted, 'IsShortlisted');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/employee-candidates/field-values`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryFieldValuesOrganisationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public queryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryFieldValuesOrganisationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public queryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryFieldValuesOrganisationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public queryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryFieldValuesOrganisationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling queryFieldValuesOrganisationSnapshots.'
      );
    }
    const targetProperty = requestParameters?.targetProperty;
    const orgCode = requestParameters?.orgCode;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (orgCode !== undefined && orgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgCode, 'OrgCode');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/field-values`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get possible field values for given record property
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesRecords(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryFieldValuesRecordsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public queryFieldValuesRecords(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryFieldValuesRecordsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public queryFieldValuesRecords(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryFieldValuesRecordsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public queryFieldValuesRecords(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryFieldValuesRecordsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    if (targetProperty === null || targetProperty === undefined) {
      throw new Error('Required parameter targetProperty was null or undefined when calling queryFieldValuesRecords.');
    }
    const memberId = requestParameters?.memberId;
    const gid = requestParameters?.gid;
    const firstName = requestParameters?.firstName;
    const lastName = requestParameters?.lastName;
    const country = requestParameters?.country;
    const are = requestParameters?.are;
    const orgCode = requestParameters?.orgCode;
    const state = requestParameters?.state;
    const planName = requestParameters?.planName;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    const assignmentId = requestParameters?.assignmentId;
    const isDesignReady = requestParameters?.isDesignReady;
    const letterState = requestParameters?.letterState;
    const payoutState = requestParameters?.payoutState;
    const template = requestParameters?.template;
    const workflow = requestParameters?.workflow;
    const seasonId = requestParameters?.seasonId;
    const workflowInstanceState = requestParameters?.workflowInstanceState;
    const lineManagerName = requestParameters?.lineManagerName;
    const lineManagerGid = requestParameters?.lineManagerGid;
    const lineManagerPositionClass = requestParameters?.lineManagerPositionClass;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (memberId !== undefined && memberId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>memberId, 'MemberId');
    }
    if (gid) {
      gid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Gid');
      });
    }
    if (firstName) {
      firstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'FirstName');
      });
    }
    if (lastName) {
      lastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LastName');
      });
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (are) {
      are.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Are');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (state) {
      state.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'State');
      });
    }
    if (planName) {
      planName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PlanName');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (assignmentId !== undefined && assignmentId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>assignmentId, 'AssignmentId');
    }
    if (isDesignReady !== undefined && isDesignReady !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isDesignReady, 'IsDesignReady');
    }
    if (letterState) {
      letterState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LetterState');
      });
    }
    if (payoutState) {
      payoutState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PayoutState');
      });
    }
    if (template !== undefined && template !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>template, 'Template');
    }
    if (workflow !== undefined && workflow !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>workflow, 'Workflow');
    }
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }
    if (workflowInstanceState) {
      workflowInstanceState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkflowInstanceState');
      });
    }
    if (lineManagerName !== undefined && lineManagerName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>lineManagerName, 'LineManagerName');
    }
    if (lineManagerGid) {
      lineManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LineManagerGid');
      });
    }
    if (lineManagerPositionClass !== undefined && lineManagerPositionClass !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>lineManagerPositionClass,
        'LineManagerPositionClass'
      );
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/records/field-values`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryInformationOrganisationInformationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>;
  public queryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryInformationOrganisationInformationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpResponse<SharedPageModelOfSeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>
  >;
  public queryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryInformationOrganisationInformationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpEvent<SharedPageModelOfSeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>
  >;
  public queryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryInformationOrganisationInformationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling queryInformationOrganisationInformationSnapshots.'
      );
    }
    const orgCode = requestParameters?.orgCode;
    const orgName = requestParameters?.orgName;
    const orgSize = requestParameters?.orgSize;
    const revenue = requestParameters?.revenue;
    const headCount = requestParameters?.headCount;
    const revenueOrgSize = requestParameters?.revenueOrgSize;
    const headCountOrgSize = requestParameters?.headCountOrgSize;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgName) {
      orgName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgName');
      });
    }
    if (orgSize !== undefined && orgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgSize, 'OrgSize');
    }
    if (revenue !== undefined && revenue !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>revenue, 'Revenue');
    }
    if (headCount !== undefined && headCount !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>headCount, 'HeadCount');
    }
    if (revenueOrgSize !== undefined && revenueOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>revenueOrgSize, 'RevenueOrgSize');
    }
    if (headCountOrgSize !== undefined && headCountOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>headCountOrgSize,
        'HeadCountOrgSize'
      );
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information`;
    return this.httpClient.request<SharedPageModelOfSeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryInformationVisibilitySettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfMeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>;
  public queryInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryInformationVisibilitySettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpResponse<SharedPageModelOfMeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>
  >;
  public queryInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryInformationVisibilitySettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfMeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>>;
  public queryInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryInformationVisibilitySettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling queryInformationVisibilitySettings.'
      );
    }
    const queryTargetProperty = requestParameters?.queryTargetProperty;
    const queryTargetTypeString = requestParameters?.queryTargetTypeString;
    const querySimulationId = requestParameters?.querySimulationId;
    const queryPriority = requestParameters?.queryPriority;
    const queryTitle = requestParameters?.queryTitle;
    const queryAffectedCount = requestParameters?.queryAffectedCount;
    const queryType = requestParameters?.queryType;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryTargetProperty !== undefined && queryTargetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryTargetProperty,
        'Query.TargetProperty'
      );
    }
    if (queryTargetTypeString !== undefined && queryTargetTypeString !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryTargetTypeString,
        'Query.TargetTypeString'
      );
    }
    if (querySimulationId !== undefined && querySimulationId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>querySimulationId,
        'Query.SimulationId'
      );
    }
    if (queryPriority !== undefined && queryPriority !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryPriority, 'Query.Priority');
    }
    if (queryTitle !== undefined && queryTitle !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryTitle, 'Query.Title');
    }
    if (queryAffectedCount !== undefined && queryAffectedCount !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAffectedCount,
        'Query.AffectedCount'
      );
    }
    if (queryType !== undefined && queryType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryType, 'Query.Type');
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility`;
    return this.httpClient.request<SharedPageModelOfMeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryMembersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsMembersMemberModel>;
  public queryMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryMembersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsMembersMemberModel>>;
  public queryMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryMembersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsMembersMemberModel>>;
  public queryMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryMembersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/members`;
    return this.httpClient.request<SharedPageModelOfSeasonsMembersMemberModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryOrganisationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsOrganisationSnapshotsOrganisationSnapshotModel>;
  public queryOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryOrganisationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsOrganisationSnapshotsOrganisationSnapshotModel>>;
  public queryOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryOrganisationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsOrganisationSnapshotsOrganisationSnapshotModel>>;
  public queryOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryOrganisationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling queryOrganisationSnapshots.');
    }
    const querySeasonId = requestParameters?.querySeasonId;
    const queryOrganisationId = requestParameters?.queryOrganisationId;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryOrgLevel = requestParameters?.queryOrgLevel;
    const queryParentOrgCode = requestParameters?.queryParentOrgCode;
    const queryHeadId = requestParameters?.queryHeadId;
    const queryHeadGid = requestParameters?.queryHeadGid;
    const queryHeadName = requestParameters?.queryHeadName;
    const queryPositionName = requestParameters?.queryPositionName;
    const queryAdditionalLineOne = requestParameters?.queryAdditionalLineOne;
    const queryAdditionalLineTwo = requestParameters?.queryAdditionalLineTwo;
    const queryAdditionalLineThree = requestParameters?.queryAdditionalLineThree;
    const queryAdditionalLineFour = requestParameters?.queryAdditionalLineFour;
    const queryOrgName = requestParameters?.queryOrgName;
    const queryOrgType = requestParameters?.queryOrgType;
    const queryOrgLevelA = requestParameters?.queryOrgLevelA;
    const queryOrgLevelB = requestParameters?.queryOrgLevelB;
    const queryOrgLevelC = requestParameters?.queryOrgLevelC;
    const queryOrgLevelD = requestParameters?.queryOrgLevelD;
    const queryNumberOfEmployees = requestParameters?.queryNumberOfEmployees;
    const queryHeadFirstname = requestParameters?.queryHeadFirstname;
    const queryHeadLastname = requestParameters?.queryHeadLastname;
    const queryHeadPAOrgCode = requestParameters?.queryHeadPAOrgCode;
    const queryHeadPlaceOfAction = requestParameters?.queryHeadPlaceOfAction;
    const queryHeadMercerJobCode = requestParameters?.queryHeadMercerJobCode;
    const queryHeadMercerPositionClass = requestParameters?.queryHeadMercerPositionClass;
    const queryHeadManagementGroup = requestParameters?.queryHeadManagementGroup;
    const queryOrgSize = requestParameters?.queryOrgSize;
    const queryRevenue = requestParameters?.queryRevenue;
    const queryHeadCount = requestParameters?.queryHeadCount;
    const queryRevenueOrgSize = requestParameters?.queryRevenueOrgSize;
    const queryHeadCountOrgSize = requestParameters?.queryHeadCountOrgSize;
    const queryShowOrganisationsWithoutOrgInfos = requestParameters?.queryShowOrganisationsWithoutOrgInfos;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (querySeasonId !== undefined && querySeasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>querySeasonId, 'Query.SeasonId');
    }
    if (queryOrganisationId !== undefined && queryOrganisationId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryOrganisationId,
        'Query.OrganisationId'
      );
    }
    if (queryOrgCode) {
      queryOrgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgCode');
      });
    }
    if (queryOrgLevel !== undefined && queryOrgLevel !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgLevel, 'Query.OrgLevel');
    }
    if (queryParentOrgCode !== undefined && queryParentOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryParentOrgCode,
        'Query.ParentOrgCode'
      );
    }
    if (queryHeadId !== undefined && queryHeadId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryHeadId, 'Query.HeadId');
    }
    if (queryHeadGid !== undefined && queryHeadGid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryHeadGid, 'Query.HeadGid');
    }
    if (queryHeadName !== undefined && queryHeadName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryHeadName, 'Query.HeadName');
    }
    if (queryPositionName !== undefined && queryPositionName !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryPositionName,
        'Query.PositionName'
      );
    }
    if (queryAdditionalLineOne !== undefined && queryAdditionalLineOne !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAdditionalLineOne,
        'Query.AdditionalLineOne'
      );
    }
    if (queryAdditionalLineTwo !== undefined && queryAdditionalLineTwo !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAdditionalLineTwo,
        'Query.AdditionalLineTwo'
      );
    }
    if (queryAdditionalLineThree !== undefined && queryAdditionalLineThree !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAdditionalLineThree,
        'Query.AdditionalLineThree'
      );
    }
    if (queryAdditionalLineFour !== undefined && queryAdditionalLineFour !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAdditionalLineFour,
        'Query.AdditionalLineFour'
      );
    }
    if (queryOrgName !== undefined && queryOrgName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgName, 'Query.OrgName');
    }
    if (queryOrgType !== undefined && queryOrgType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgType, 'Query.OrgType');
    }
    if (queryOrgLevelA !== undefined && queryOrgLevelA !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgLevelA, 'Query.OrgLevelA');
    }
    if (queryOrgLevelB !== undefined && queryOrgLevelB !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgLevelB, 'Query.OrgLevelB');
    }
    if (queryOrgLevelC !== undefined && queryOrgLevelC !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgLevelC, 'Query.OrgLevelC');
    }
    if (queryOrgLevelD !== undefined && queryOrgLevelD !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgLevelD, 'Query.OrgLevelD');
    }
    if (queryNumberOfEmployees !== undefined && queryNumberOfEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryNumberOfEmployees,
        'Query.NumberOfEmployees'
      );
    }
    if (queryHeadFirstname !== undefined && queryHeadFirstname !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadFirstname,
        'Query.HeadFirstname'
      );
    }
    if (queryHeadLastname !== undefined && queryHeadLastname !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadLastname,
        'Query.HeadLastname'
      );
    }
    if (queryHeadPAOrgCode !== undefined && queryHeadPAOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadPAOrgCode,
        'Query.HeadPAOrgCode'
      );
    }
    if (queryHeadPlaceOfAction !== undefined && queryHeadPlaceOfAction !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadPlaceOfAction,
        'Query.HeadPlaceOfAction'
      );
    }
    if (queryHeadMercerJobCode !== undefined && queryHeadMercerJobCode !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadMercerJobCode,
        'Query.HeadMercerJobCode'
      );
    }
    if (queryHeadMercerPositionClass !== undefined && queryHeadMercerPositionClass !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadMercerPositionClass,
        'Query.HeadMercerPositionClass'
      );
    }
    if (queryHeadManagementGroup !== undefined && queryHeadManagementGroup !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadManagementGroup,
        'Query.HeadManagementGroup'
      );
    }
    if (queryOrgSize !== undefined && queryOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgSize, 'Query.OrgSize');
    }
    if (queryRevenue !== undefined && queryRevenue !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryRevenue, 'Query.Revenue');
    }
    if (queryHeadCount !== undefined && queryHeadCount !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryHeadCount, 'Query.HeadCount');
    }
    if (queryRevenueOrgSize !== undefined && queryRevenueOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryRevenueOrgSize,
        'Query.RevenueOrgSize'
      );
    }
    if (queryHeadCountOrgSize !== undefined && queryHeadCountOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadCountOrgSize,
        'Query.HeadCountOrgSize'
      );
    }
    if (queryShowOrganisationsWithoutOrgInfos !== undefined && queryShowOrganisationsWithoutOrgInfos !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryShowOrganisationsWithoutOrgInfos,
        'Query.ShowOrganisationsWithoutOrgInfos'
      );
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations`;
    return this.httpClient.request<SharedPageModelOfSeasonsOrganisationSnapshotsOrganisationSnapshotModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsSnapshotsSnapshotModel>;
  public queryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsSnapshotsSnapshotModel>>;
  public queryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsSnapshotsSnapshotModel>>;
  public queryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const meritSeasonId = requestParameters?.meritSeasonId;
    const search = requestParameters?.search;
    const directs = requestParameters?.directs;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const impersonatedEmployee = requestParameters?.impersonatedEmployee;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }
    if (meritSeasonId !== undefined && meritSeasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>meritSeasonId, 'MeritSeasonId');
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (directs !== undefined && directs !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>directs, 'Directs');
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (impersonatedEmployee !== undefined && impersonatedEmployee !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>impersonatedEmployee,
        'impersonatedEmployee'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/snapshots/employees`;
    return this.httpClient.request<SharedPageModelOfSeasonsSnapshotsSnapshotModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryParentsOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryParentsOrganisationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsOrganisationSnapshotsOrganisationSnapshotModel>;
  public queryParentsOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryParentsOrganisationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsOrganisationSnapshotsOrganisationSnapshotModel>>;
  public queryParentsOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryParentsOrganisationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsOrganisationSnapshotsOrganisationSnapshotModel>>;
  public queryParentsOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryParentsOrganisationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling queryParentsOrganisationSnapshots.'
      );
    }
    const seasonId2 = requestParameters?.seasonId2;
    if (seasonId2 === null || seasonId2 === undefined) {
      throw new Error(
        'Required parameter seasonId2 was null or undefined when calling queryParentsOrganisationSnapshots.'
      );
    }
    const queryOrgCode = requestParameters?.queryOrgCode;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (seasonId2 !== undefined && seasonId2 !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId2, 'SeasonId');
    }
    if (queryOrgCode !== undefined && queryOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgCode, 'Query.OrgCode');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/parents`;
    return this.httpClient.request<SeasonsOrganisationSnapshotsOrganisationSnapshotModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryPlanWithMissingIndividualValuesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsPlanWithMissingIndividualValuesPlanWithMissingIndividualValuesModel>;
  public queryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryPlanWithMissingIndividualValuesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpResponse<SharedPageModelOfSeasonsPlanWithMissingIndividualValuesPlanWithMissingIndividualValuesModel>
  >;
  public queryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryPlanWithMissingIndividualValuesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsPlanWithMissingIndividualValuesPlanWithMissingIndividualValuesModel>>;
  public queryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryPlanWithMissingIndividualValuesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const queryKpiId = requestParameters?.queryKpiId;
    const queryAssignmentId = requestParameters?.queryAssignmentId;
    const queryOrgClusterNodeName = requestParameters?.queryOrgClusterNodeName;
    const queryGid = requestParameters?.queryGid;
    const queryLastname = requestParameters?.queryLastname;
    const queryFirstname = requestParameters?.queryFirstname;
    const queryCountry = requestParameters?.queryCountry;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryRecordStartdate = requestParameters?.queryRecordStartdate;
    const queryPlanName = requestParameters?.queryPlanName;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }
    if (queryKpiId !== undefined && queryKpiId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryKpiId, 'Query.KpiId');
    }
    if (queryAssignmentId !== undefined && queryAssignmentId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAssignmentId,
        'Query.AssignmentId'
      );
    }
    if (queryOrgClusterNodeName !== undefined && queryOrgClusterNodeName !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryOrgClusterNodeName,
        'Query.OrgClusterNodeName'
      );
    }
    if (queryGid !== undefined && queryGid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryGid, 'Query.Gid');
    }
    if (queryLastname !== undefined && queryLastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryLastname, 'Query.Lastname');
    }
    if (queryFirstname !== undefined && queryFirstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryFirstname, 'Query.Firstname');
    }
    if (queryCountry !== undefined && queryCountry !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryCountry, 'Query.Country');
    }
    if (queryOrgCode !== undefined && queryOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgCode, 'Query.OrgCode');
    }
    if (queryRecordStartdate !== undefined && queryRecordStartdate !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryRecordStartdate,
        'Query.RecordStartdate'
      );
    }
    if (queryPlanName !== undefined && queryPlanName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryPlanName, 'Query.PlanName');
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/season-plans/missing-individual-values`;
    return this.httpClient.request<SharedPageModelOfSeasonsPlanWithMissingIndividualValuesPlanWithMissingIndividualValuesModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryPlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsPlansPlanModel>;
  public queryPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryPlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsPlansPlanModel>>;
  public queryPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryPlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsPlansPlanModel>>;
  public queryPlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQueryPlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const seasonId = requestParameters?.seasonId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'seasonId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/plans`;
    return this.httpClient.request<SharedPageModelOfSeasonsPlansPlanModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryPossibilitiesBudgetBuckets(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<SeasonsBudgetComponentsBucketComponentsPossibilitiesModel>>;
  public queryPossibilitiesBudgetBuckets(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<SeasonsBudgetComponentsBucketComponentsPossibilitiesModel>>>;
  public queryPossibilitiesBudgetBuckets(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<SeasonsBudgetComponentsBucketComponentsPossibilitiesModel>>>;
  public queryPossibilitiesBudgetBuckets(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/budget-bucket/component-settings`;
    return this.httpClient.request<Array<SeasonsBudgetComponentsBucketComponentsPossibilitiesModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public querySeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQuerySeasonsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsSeasonsSeasonModel>;
  public querySeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQuerySeasonsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsSeasonsSeasonModel>>;
  public querySeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQuerySeasonsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsSeasonsSeasonModel>>;
  public querySeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQuerySeasonsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const seasonType = requestParameters?.seasonType;
    const simulationState = requestParameters?.simulationState;
    const queryManagerEndDateAt = requestParameters?.queryManagerEndDateAt;
    const queryPartnerEndDateAt = requestParameters?.queryPartnerEndDateAt;
    const querySeasonType = requestParameters?.querySeasonType;
    const querySimulationState = requestParameters?.querySimulationState;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (seasonType) {
      seasonType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'SeasonType');
      });
    }
    if (simulationState) {
      simulationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'SimulationState');
      });
    }
    if (queryManagerEndDateAt !== undefined && queryManagerEndDateAt !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryManagerEndDateAt,
        'Query.ManagerEndDateAt'
      );
    }
    if (queryPartnerEndDateAt !== undefined && queryPartnerEndDateAt !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryPartnerEndDateAt,
        'Query.PartnerEndDateAt'
      );
    }
    if (querySeasonType) {
      querySeasonType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.SeasonType');
      });
    }
    if (querySimulationState) {
      querySimulationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.SimulationState');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons`;
    return this.httpClient.request<SharedPageModelOfSeasonsSeasonsSeasonModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public querySimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQuerySimulationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<PositionEvaluationSimulationsPositionEvaluationSimulationModel>>;
  public querySimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQuerySimulationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<PositionEvaluationSimulationsPositionEvaluationSimulationModel>>>;
  public querySimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQuerySimulationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<PositionEvaluationSimulationsPositionEvaluationSimulationModel>>>;
  public querySimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQuerySimulationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling querySimulation.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations`;
    return this.httpClient.request<Array<PositionEvaluationSimulationsPositionEvaluationSimulationModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public querySpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQuerySpecialPaymentGlobalHrbpApproverRulesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSpecialPaymentsGlobalHrbpRulesSpecialPaymentGlobalHrbpApproverRuleModel>;
  public querySpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQuerySpecialPaymentGlobalHrbpApproverRulesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSpecialPaymentsGlobalHrbpRulesSpecialPaymentGlobalHrbpApproverRuleModel>>;
  public querySpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQuerySpecialPaymentGlobalHrbpApproverRulesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSpecialPaymentsGlobalHrbpRulesSpecialPaymentGlobalHrbpApproverRuleModel>>;
  public querySpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: SeasonsSpecialPaymentAdminServiceQuerySpecialPaymentGlobalHrbpApproverRulesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling querySpecialPaymentGlobalHrbpApproverRules.'
      );
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/global-hrbp-rules`;
    return this.httpClient.request<SharedPageModelOfSpecialPaymentsGlobalHrbpRulesSpecialPaymentGlobalHrbpApproverRuleModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculateCandidatePools(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfCandidatePoolRecalculationMetadata>;
  public recalculateCandidatePools(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfCandidatePoolRecalculationMetadata>>;
  public recalculateCandidatePools(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfCandidatePoolRecalculationMetadata>>;
  public recalculateCandidatePools(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/candidate-pools/recalculate`;
    return this.httpClient.request<TransactionStatusOfCandidatePoolRecalculationMetadata>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceRecalculateParentSettingsPopulationSimulationPopulationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSettingsPopulationRecalculationMetadata>;
  public recalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceRecalculateParentSettingsPopulationSimulationPopulationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public recalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceRecalculateParentSettingsPopulationSimulationPopulationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public recalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceRecalculateParentSettingsPopulationSimulationPopulationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling recalculateParentSettingsPopulationSimulationPopulations.'
      );
    }
    const parentSettingId = requestParameters?.parentSettingId;
    if (parentSettingId === null || parentSettingId === undefined) {
      throw new Error(
        'Required parameter parentSettingId was null or undefined when calling recalculateParentSettingsPopulationSimulationPopulations.'
      );
    }
    const settingsType = requestParameters?.settingsType;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (settingsType !== undefined && settingsType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>settingsType, 'settingsType');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/population-recalculation/${this.configuration.encodeParam({ name: 'parentSettingId', value: parentSettingId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<TransactionStatusOfSettingsPopulationRecalculationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculatePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceRecalculatePlanPopulationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfPlanPopulationRecalculationMetadata>;
  public recalculatePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceRecalculatePlanPopulationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfPlanPopulationRecalculationMetadata>>;
  public recalculatePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceRecalculatePlanPopulationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfPlanPopulationRecalculationMetadata>>;
  public recalculatePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceRecalculatePlanPopulationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling recalculatePlanPopulations.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/plans/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/population-recalculation`;
    return this.httpClient.request<TransactionStatusOfPlanPopulationRecalculationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceRecalculateSettingsPopulationSimulationPopulationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSettingsPopulationRecalculationMetadata>;
  public recalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceRecalculateSettingsPopulationSimulationPopulationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public recalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceRecalculateSettingsPopulationSimulationPopulationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public recalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceRecalculateSettingsPopulationSimulationPopulationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling recalculateSettingsPopulationSimulationPopulations.'
      );
    }
    const settingsType = requestParameters?.settingsType;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (settingsType !== undefined && settingsType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>settingsType, 'settingsType');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/population-recalculation`;
    return this.httpClient.request<TransactionStatusOfSettingsPopulationRecalculationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public reorderSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: SeasonsSpecialPaymentAdminServiceReorderSpecialPaymentGlobalHrbpApproverRulesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<boolean>;
  public reorderSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: SeasonsSpecialPaymentAdminServiceReorderSpecialPaymentGlobalHrbpApproverRulesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<boolean>>;
  public reorderSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: SeasonsSpecialPaymentAdminServiceReorderSpecialPaymentGlobalHrbpApproverRulesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<boolean>>;
  public reorderSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: SeasonsSpecialPaymentAdminServiceReorderSpecialPaymentGlobalHrbpApproverRulesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling reorderSpecialPaymentGlobalHrbpApproverRules.'
      );
    }
    const requestBody = requestParameters?.requestBody;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/global-hrbp-rules/priorities`;
    return this.httpClient.request<boolean>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: requestBody,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public savePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceSavePlanPopulationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfPlanPopulationCreationMetadata>;
  public savePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceSavePlanPopulationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfPlanPopulationCreationMetadata>>;
  public savePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceSavePlanPopulationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfPlanPopulationCreationMetadata>>;
  public savePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceSavePlanPopulationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling savePlanPopulations.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/save-population`;
    return this.httpClient.request<TransactionStatusOfPlanPopulationCreationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public saveSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceSaveSeasonPopulationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfPopulationCreationMetadata>;
  public saveSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceSaveSeasonPopulationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfPopulationCreationMetadata>>;
  public saveSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceSaveSeasonPopulationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfPopulationCreationMetadata>>;
  public saveSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceSaveSeasonPopulationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling saveSeasonPopulations.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/save-population`;
    return this.httpClient.request<TransactionStatusOfPopulationCreationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulatePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceSimulatePlanPopulationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsRemPopulationCreatedResultPagedDto>;
  public simulatePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceSimulatePlanPopulationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsRemPopulationCreatedResultPagedDto>>;
  public simulatePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceSimulatePlanPopulationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsRemPopulationCreatedResultPagedDto>>;
  public simulatePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceSimulatePlanPopulationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling simulatePlanPopulations.');
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const sharedRuleEngineRuleSetModel = requestParameters?.sharedRuleEngineRuleSetModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`;
    return this.httpClient.request<SeasonsRemPopulationCreatedResultPagedDto>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: sharedRuleEngineRuleSetModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceSimulateRuleInformationVisibilitySettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmployeesEmployeesEmployeeModel>;
  public simulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceSimulateRuleInformationVisibilitySettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmployeesEmployeesEmployeeModel>>;
  public simulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceSimulateRuleInformationVisibilitySettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmployeesEmployeesEmployeeModel>>;
  public simulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceSimulateRuleInformationVisibilitySettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const settingsId = requestParameters?.settingsId;
    if (settingsId === null || settingsId === undefined) {
      throw new Error(
        'Required parameter settingsId was null or undefined when calling simulateRuleInformationVisibilitySettings.'
      );
    }
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling simulateRuleInformationVisibilitySettings.'
      );
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const sharedRuleEngineRuleSetModel = requestParameters?.sharedRuleEngineRuleSetModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility/${this.configuration.encodeParam({ name: 'settingsId', value: settingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`;
    return this.httpClient.request<SharedPageModelOfEmployeesEmployeesEmployeeModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: sharedRuleEngineRuleSetModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulateSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceSimulateSeasonPopulationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsRemEmployeePopulationCreatedResultPagedDto>;
  public simulateSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceSimulateSeasonPopulationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsRemEmployeePopulationCreatedResultPagedDto>>;
  public simulateSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceSimulateSeasonPopulationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsRemEmployeePopulationCreatedResultPagedDto>>;
  public simulateSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminServiceSimulateSeasonPopulationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling simulateSeasonPopulations.');
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const _export = requestParameters?._export;
    const sharedRuleEngineRuleSetModel = requestParameters?.sharedRuleEngineRuleSetModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (_export !== undefined && _export !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>_export, 'export');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`;
    return this.httpClient.request<SeasonsRemEmployeePopulationCreatedResultPagedDto>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: sharedRuleEngineRuleSetModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public unPrePublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUnPrePublishSimulationPublicationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public unPrePublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUnPrePublishSimulationPublicationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public unPrePublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUnPrePublishSimulationPublicationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public unPrePublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUnPrePublishSimulationPublicationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling unPrePublishSimulationPublications.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/un-pre-publish`;
    return this.httpClient.request<TransactionStatusOfSimulationPublishMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public unPublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUnPublishSimulationPublicationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public unPublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUnPublishSimulationPublicationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public unPublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUnPublishSimulationPublicationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public unPublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUnPublishSimulationPublicationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling unPublishSimulationPublications.'
      );
    }
    const queryPositionName = requestParameters?.queryPositionName;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryOrgCodeStartsWith = requestParameters?.queryOrgCodeStartsWith;
    const queryOrgLevel = requestParameters?.queryOrgLevel;
    const queryOrgSize = requestParameters?.queryOrgSize;
    const queryMercerJobCode = requestParameters?.queryMercerJobCode;
    const queryPositionClass = requestParameters?.queryPositionClass;
    const queryNewPositionClass = requestParameters?.queryNewPositionClass;
    const queryOriginalProposedPositionClass = requestParameters?.queryOriginalProposedPositionClass;
    const queryPositionType = requestParameters?.queryPositionType;
    const queryCountryIsoCode = requestParameters?.queryCountryIsoCode;
    const queryIncumbentGid = requestParameters?.queryIncumbentGid;
    const queryIncumbentFirstName = requestParameters?.queryIncumbentFirstName;
    const queryIncumbentLastName = requestParameters?.queryIncumbentLastName;
    const queryIncumbentCountryPlaceOfAction = requestParameters?.queryIncumbentCountryPlaceOfAction;
    const queryValidationManagerId = requestParameters?.queryValidationManagerId;
    const queryValidationManagerGid = requestParameters?.queryValidationManagerGid;
    const queryValidationManagerFirstName = requestParameters?.queryValidationManagerFirstName;
    const queryValidationManagerLastName = requestParameters?.queryValidationManagerLastName;
    const queryValidationState = requestParameters?.queryValidationState;
    const queryPlacementState = requestParameters?.queryPlacementState;
    const queryNewHireState = requestParameters?.queryNewHireState;
    const queryIsLocked = requestParameters?.queryIsLocked;
    const queryMercerJobFamily = requestParameters?.queryMercerJobFamily;
    const queryMercerJobSpecialization = requestParameters?.queryMercerJobSpecialization;
    const queryMercerJobSubFamily = requestParameters?.queryMercerJobSubFamily;
    const queryIncumbentAre = requestParameters?.queryIncumbentAre;
    const queryTag = requestParameters?.queryTag;
    const queryWasPromoted = requestParameters?.queryWasPromoted;
    const queryIsTransferred = requestParameters?.queryIsTransferred;
    const seasonsSimulationPublicationsUnPublishSimulationModel =
      requestParameters?.seasonsSimulationPublicationsUnPublishSimulationModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryPositionName) {
      queryPositionName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PositionName');
      });
    }
    if (queryOrgCode) {
      queryOrgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgCode');
      });
    }
    if (queryOrgCodeStartsWith) {
      queryOrgCodeStartsWith.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.OrgCodeStartsWith'
        );
      });
    }
    if (queryOrgLevel) {
      queryOrgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgLevel');
      });
    }
    if (queryOrgSize) {
      queryOrgSize.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgSize');
      });
    }
    if (queryMercerJobCode) {
      queryMercerJobCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.MercerJobCode');
      });
    }
    if (queryPositionClass) {
      queryPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PositionClass');
      });
    }
    if (queryNewPositionClass) {
      queryNewPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.NewPositionClass');
      });
    }
    if (queryOriginalProposedPositionClass) {
      queryOriginalProposedPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.OriginalProposedPositionClass'
        );
      });
    }
    if (queryPositionType) {
      queryPositionType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PositionType');
      });
    }
    if (queryCountryIsoCode) {
      queryCountryIsoCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.CountryIsoCode');
      });
    }
    if (queryIncumbentGid) {
      queryIncumbentGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IncumbentGid');
      });
    }
    if (queryIncumbentFirstName) {
      queryIncumbentFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncumbentFirstName'
        );
      });
    }
    if (queryIncumbentLastName) {
      queryIncumbentLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncumbentLastName'
        );
      });
    }
    if (queryIncumbentCountryPlaceOfAction) {
      queryIncumbentCountryPlaceOfAction.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncumbentCountryPlaceOfAction'
        );
      });
    }
    if (queryValidationManagerId) {
      queryValidationManagerId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerId'
        );
      });
    }
    if (queryValidationManagerGid) {
      queryValidationManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerGid'
        );
      });
    }
    if (queryValidationManagerFirstName) {
      queryValidationManagerFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerFirstName'
        );
      });
    }
    if (queryValidationManagerLastName) {
      queryValidationManagerLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerLastName'
        );
      });
    }
    if (queryValidationState) {
      queryValidationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ValidationState');
      });
    }
    if (queryPlacementState) {
      queryPlacementState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PlacementState');
      });
    }
    if (queryNewHireState) {
      queryNewHireState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.NewHireState');
      });
    }
    if (queryIsLocked) {
      queryIsLocked.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IsLocked');
      });
    }
    if (queryMercerJobFamily) {
      queryMercerJobFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.MercerJobFamily');
      });
    }
    if (queryMercerJobSpecialization) {
      queryMercerJobSpecialization.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.MercerJobSpecialization'
        );
      });
    }
    if (queryMercerJobSubFamily) {
      queryMercerJobSubFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.MercerJobSubFamily'
        );
      });
    }
    if (queryIncumbentAre) {
      queryIncumbentAre.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IncumbentAre');
      });
    }
    if (queryTag) {
      queryTag.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Tag');
      });
    }
    if (queryWasPromoted) {
      queryWasPromoted.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.WasPromoted');
      });
    }
    if (queryIsTransferred) {
      queryIsTransferred.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IsTransferred');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/un-publish`;
    return this.httpClient.request<TransactionStatusOfSimulationPublishMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSimulationPublicationsUnPublishSimulationModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateBenchmarkValuesSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfImportStatusMetadata>;
  public updateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateBenchmarkValuesSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfImportStatusMetadata>>;
  public updateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateBenchmarkValuesSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfImportStatusMetadata>>;
  public updateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateBenchmarkValuesSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsSnapshotsUpdateSnapshotBenchmarkValuesModel =
      requestParameters?.seasonsSnapshotsUpdateSnapshotBenchmarkValuesModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/snapshots/benchmarks`;
    return this.httpClient.request<TransactionStatusOfImportStatusMetadata>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSnapshotsUpdateSnapshotBenchmarkValuesModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateBucketComponentBatchBudgetComponentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsBudgetComponentsBucketComponentModificationResponseModel>;
  public updateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateBucketComponentBatchBudgetComponentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsBudgetComponentsBucketComponentModificationResponseModel>>;
  public updateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateBucketComponentBatchBudgetComponentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsBudgetComponentsBucketComponentModificationResponseModel>>;
  public updateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateBucketComponentBatchBudgetComponentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    if (budgetBucketId === null || budgetBucketId === undefined) {
      throw new Error(
        'Required parameter budgetBucketId was null or undefined when calling updateBucketComponentBatchBudgetComponents.'
      );
    }
    const seasonsBudgetComponentsUpdateManyBucketComponentsModel =
      requestParameters?.seasonsBudgetComponentsUpdateManyBucketComponentsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/budget-components/batch`;
    return this.httpClient.request<SeasonsBudgetComponentsBucketComponentModificationResponseModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsBudgetComponentsUpdateManyBucketComponentsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateBucketComponentBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateBucketComponentBudgetComponentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsBudgetComponentsBucketComponentModificationResponseModel>;
  public updateBucketComponentBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateBucketComponentBudgetComponentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsBudgetComponentsBucketComponentModificationResponseModel>>;
  public updateBucketComponentBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateBucketComponentBudgetComponentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsBudgetComponentsBucketComponentModificationResponseModel>>;
  public updateBucketComponentBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateBucketComponentBudgetComponentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    if (budgetBucketId === null || budgetBucketId === undefined) {
      throw new Error(
        'Required parameter budgetBucketId was null or undefined when calling updateBucketComponentBudgetComponents.'
      );
    }
    const seasonsBudgetComponentsUpdateBucketComponentModel =
      requestParameters?.seasonsBudgetComponentsUpdateBucketComponentModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-components`;
    return this.httpClient.request<SeasonsBudgetComponentsBucketComponentModificationResponseModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsBudgetComponentsUpdateBucketComponentModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateBudgetBucketsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsBudgetBucketsBudgetBucketModificationResponseModel>;
  public updateBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateBudgetBucketsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsBudgetBucketsBudgetBucketModificationResponseModel>>;
  public updateBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateBudgetBucketsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsBudgetBucketsBudgetBucketModificationResponseModel>>;
  public updateBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateBudgetBucketsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updateBudgetBuckets.');
    }
    const seasonsBudgetBucketsUpdateBudgetBucketModel = requestParameters?.seasonsBudgetBucketsUpdateBudgetBucketModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/budget-bucket/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsBudgetBucketsBudgetBucketModificationResponseModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsBudgetBucketsUpdateBudgetBucketModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateCandidatePoolsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsCandidatePoolsCandidatePoolModel>;
  public updateCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateCandidatePoolsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsCandidatePoolsCandidatePoolModel>>;
  public updateCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateCandidatePoolsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsCandidatePoolsCandidatePoolModel>>;
  public updateCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateCandidatePoolsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updateCandidatePools.');
    }
    const seasonsCandidatePoolsUpdateCandidatePoolModel =
      requestParameters?.seasonsCandidatePoolsUpdateCandidatePoolModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/candidate-pools/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsCandidatePoolsCandidatePoolModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsCandidatePoolsUpdateCandidatePoolModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateEmployeeSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>;
  public updateEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateEmployeeSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>>;
  public updateEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateEmployeeSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>>;
  public updateEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateEmployeeSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsEmployeeSnapshotsUpdateEmployeeSnapshotModel =
      requestParameters?.seasonsEmployeeSnapshotsUpdateEmployeeSnapshotModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/employee-snapshots`;
    return this.httpClient.request<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsEmployeeSnapshotsUpdateEmployeeSnapshotModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateInformationVisibilitySettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<MeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>;
  public updateInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateInformationVisibilitySettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<MeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>>;
  public updateInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateInformationVisibilitySettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<MeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>>;
  public updateInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateInformationVisibilitySettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const settingsId = requestParameters?.settingsId;
    if (settingsId === null || settingsId === undefined) {
      throw new Error(
        'Required parameter settingsId was null or undefined when calling updateInformationVisibilitySettings.'
      );
    }
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling updateInformationVisibilitySettings.'
      );
    }
    const seasonsInformationVisibilitySettingsUpdateInformationVisibilitySettingsModel =
      requestParameters?.seasonsInformationVisibilitySettingsUpdateInformationVisibilitySettingsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/settings/information-visibility/${this.configuration.encodeParam({ name: 'settingsId', value: settingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<MeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsInformationVisibilitySettingsUpdateInformationVisibilitySettingsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateManyBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateManyBudgetBucketsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsBudgetBucketsBudgetBucketModificationResponseModel>;
  public updateManyBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateManyBudgetBucketsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsBudgetBucketsBudgetBucketModificationResponseModel>>;
  public updateManyBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateManyBudgetBucketsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsBudgetBucketsBudgetBucketModificationResponseModel>>;
  public updateManyBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateManyBudgetBucketsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsBudgetBucketsUpdateManyBudgetBucketsModel =
      requestParameters?.seasonsBudgetBucketsUpdateManyBudgetBucketsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/budget-bucket/batch`;
    return this.httpClient.request<SeasonsBudgetBucketsBudgetBucketModificationResponseModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsBudgetBucketsUpdateManyBudgetBucketsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateMembersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsMembersMemberModel>;
  public updateMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateMembersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsMembersMemberModel>>;
  public updateMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateMembersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsMembersMemberModel>>;
  public updateMembers(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateMembersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsMembersUpdateMemberModel = requestParameters?.seasonsMembersUpdateMemberModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/members`;
    return this.httpClient.request<SeasonsMembersMemberModel>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: seasonsMembersUpdateMemberModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateOrganisationInformationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>;
  public updateOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateOrganisationInformationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>>;
  public updateOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateOrganisationInformationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>>;
  public updateOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateOrganisationInformationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling updateOrganisationInformationSnapshots.'
      );
    }
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling updateOrganisationInformationSnapshots.'
      );
    }
    const seasonsOrganisationInformationSnapshotsUpdateOrganisationInformationSnapshotModel =
      requestParameters?.seasonsOrganisationInformationSnapshotsUpdateOrganisationInformationSnapshotModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsOrganisationInformationSnapshotsUpdateOrganisationInformationSnapshotModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdatePlanSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsPlanSettingsPlanSettingsModel>;
  public updatePlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdatePlanSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsPlanSettingsPlanSettingsModel>>;
  public updatePlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdatePlanSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsPlanSettingsPlanSettingsModel>>;
  public updatePlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdatePlanSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updatePlanSettings.');
    }
    const planId = requestParameters?.planId;
    if (planId === null || planId === undefined) {
      throw new Error('Required parameter planId was null or undefined when calling updatePlanSettings.');
    }
    const seasonsPlanSettingsUpdatePlanSettingsModel = requestParameters?.seasonsPlanSettingsUpdatePlanSettingsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsPlanSettingsPlanSettingsModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsPlanSettingsUpdatePlanSettingsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdatePlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsPlansPlanModel>;
  public updatePlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdatePlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsPlansPlanModel>>;
  public updatePlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdatePlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsPlansPlanModel>>;
  public updatePlans(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdatePlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updatePlans.');
    }
    const seasonsPlansUpdatePlanModel = requestParameters?.seasonsPlansUpdatePlanModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsPlansPlanModel>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: seasonsPlansUpdatePlanModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdatePublicationSettingsPublicationSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsPublicationSettingsPublicationSettingsModel>;
  public updatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdatePublicationSettingsPublicationSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsPublicationSettingsPublicationSettingsModel>>;
  public updatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdatePublicationSettingsPublicationSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsPublicationSettingsPublicationSettingsModel>>;
  public updatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdatePublicationSettingsPublicationSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling updatePublicationSettingsPublicationSettings.'
      );
    }
    const seasonsPublicationSettingsUpdatePublicationSettingsModel =
      requestParameters?.seasonsPublicationSettingsUpdatePublicationSettingsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publication-settings`;
    return this.httpClient.request<SeasonsPublicationSettingsPublicationSettingsModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsPublicationSettingsUpdatePublicationSettingsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSeasonCommunicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSeasonCommunicationSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<MeritCommunicationSettingsMeritCommunicationSettingsModel>;
  public updateSeasonCommunicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSeasonCommunicationSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<MeritCommunicationSettingsMeritCommunicationSettingsModel>>;
  public updateSeasonCommunicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSeasonCommunicationSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<MeritCommunicationSettingsMeritCommunicationSettingsModel>>;
  public updateSeasonCommunicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSeasonCommunicationSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling updateSeasonCommunicationSettings.'
      );
    }
    const seasonsCommunicationSettingsUpdateCommunicationSettingsModel =
      requestParameters?.seasonsCommunicationSettingsUpdateCommunicationSettingsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/communication-settings`;
    return this.httpClient.request<MeritCommunicationSettingsMeritCommunicationSettingsModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsCommunicationSettingsUpdateCommunicationSettingsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSeasonSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSeasonSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsSettingsSeasonSettingsModel>;
  public updateSeasonSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSeasonSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsSettingsSeasonSettingsModel>>;
  public updateSeasonSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSeasonSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsSettingsSeasonSettingsModel>>;
  public updateSeasonSettings(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSeasonSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsSettingsSetSeasonSettingsModel = requestParameters?.seasonsSettingsSetSeasonSettingsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/settings`;
    return this.httpClient.request<SeasonsSettingsSeasonSettingsModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSettingsSetSeasonSettingsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSeasonsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsSeasonsSeasonModel>;
  public updateSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSeasonsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsSeasonsSeasonModel>>;
  public updateSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSeasonsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsSeasonsSeasonModel>>;
  public updateSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSeasonsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsSeasonsUpdateSeasonModel = requestParameters?.seasonsSeasonsUpdateSeasonModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons`;
    return this.httpClient.request<SeasonsSeasonsSeasonModel>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: seasonsSeasonsUpdateSeasonModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSimulationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsSimulationsSimulationModel>;
  public updateSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSimulationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsSimulationsSimulationModel>>;
  public updateSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSimulationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsSimulationsSimulationModel>>;
  public updateSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSimulationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error('Required parameter simulationId was null or undefined when calling updateSimulation.');
    }
    const seasonsSimulationsUpdateSimulationModel = requestParameters?.seasonsSimulationsUpdateSimulationModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsSimulationsSimulationModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSimulationsUpdateSimulationModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSimulationMembersSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSimulationMembersSimulationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfIMetadata>;
  public updateSimulationMembersSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSimulationMembersSimulationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfIMetadata>>;
  public updateSimulationMembersSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSimulationMembersSimulationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfIMetadata>>;
  public updateSimulationMembersSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSimulationMembersSimulationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling updateSimulationMembersSimulation.'
      );
    }
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling updateSimulationMembersSimulation.'
      );
    }
    const seasonsSimulationsUpdateSimulationMembersModel =
      requestParameters?.seasonsSimulationsUpdateSimulationMembersModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/update-members`;
    return this.httpClient.request<TransactionStatusOfIMetadata>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSimulationsUpdateSimulationMembersModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSpecialPaymentGlobalHrbpApproverRulesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SpecialPaymentsGlobalHrbpRulesSpecialPaymentGlobalHrbpApproverRuleModel>;
  public updateSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSpecialPaymentGlobalHrbpApproverRulesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SpecialPaymentsGlobalHrbpRulesSpecialPaymentGlobalHrbpApproverRuleModel>>;
  public updateSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSpecialPaymentGlobalHrbpApproverRulesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SpecialPaymentsGlobalHrbpRulesSpecialPaymentGlobalHrbpApproverRuleModel>>;
  public updateSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: SeasonsSpecialPaymentAdminServiceUpdateSpecialPaymentGlobalHrbpApproverRulesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling updateSpecialPaymentGlobalHrbpApproverRules.'
      );
    }
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling updateSpecialPaymentGlobalHrbpApproverRules.'
      );
    }
    const specialPaymentsGlobalHrbpRulesUpdateSpecialPaymentGlobalHrbpApproverRuleModel =
      requestParameters?.specialPaymentsGlobalHrbpRulesUpdateSpecialPaymentGlobalHrbpApproverRuleModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/global-hrbp-rules/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SpecialPaymentsGlobalHrbpRulesSpecialPaymentGlobalHrbpApproverRuleModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: specialPaymentsGlobalHrbpRulesUpdateSpecialPaymentGlobalHrbpApproverRuleModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }
}
